export default class MockData {
  static funnelJson = {
    "funnelData": {
      "referenceId": "ddd8051a-d53f-4a43-84a8-f8f551f1268a",
      "campaign": "44",
      "salt": "f3b68530-40ca-11ed-b32a-71223489b0dd",
      "headTrackingCode": null,
      "bodyTrackingCode": null,
      "title": "Store Funnel",
      "addOns": [{"keyName": "EN_CURR_CG_BY_CNTY", "keyValue": "true"}],
      "providers": [],
      "pages": [{
        "referenceId": "4d114e5d-bc62-4204-84a6-3c41793b4c4d",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "External Page",
        "urlSlug": null,
        "externalURL": null,
        "pageView": [{"referenceId": "bd8ca6b6-2ab0-41c3-8fac-7527220f6a78", "templateTypeId": 32, "pageType": 32}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "738e0f7b-6a25-4a33-aa54-e0cdda077140",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "Catalog",
        "urlSlug": "catalog",
        "externalURL": null,
        "pageView": [{"referenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829", "templateTypeId": 18, "pageType": 18}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "f6273e83-6c90-4e39-9788-3814a89d0344",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "Checkout Page",
        "urlSlug": "checkout",
        "externalURL": null,
        "pageView": [{"referenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57", "templateTypeId": 4, "pageType": 4}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "69fa05ab-81ec-4fe9-824d-9a3326247e96",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "Collection",
        "urlSlug": "collection",
        "externalURL": null,
        "pageView": [{"referenceId": "87218a54-cb07-48d6-9842-8af44d19763c", "templateTypeId": 17, "pageType": 17}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "aa11f4b4-3787-4395-b72d-2c2ff4c8ec93",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "Common",
        "urlSlug": "common",
        "externalURL": null,
        "pageView": [{"referenceId": "168d73d0-3399-4725-9142-8efe3f562b34", "templateTypeId": 36, "pageType": 36}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "9e46f245-6502-4089-ba07-315a9ff25ee4",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "Terms of Service",
        "urlSlug": "generic",
        "externalURL": null,
        "pageView": [{"referenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b", "templateTypeId": 14, "pageType": 14}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "22ed9553-0d6e-4b76-b594-2ff51b9ed23a",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "Return Policy",
        "urlSlug": "generic1",
        "externalURL": null,
        "pageView": [{"referenceId": "244cceed-d818-4689-932f-142c9941ffcc", "templateTypeId": 14, "pageType": 14}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "67f17640-4a63-4614-8585-5381b6c6f5e2",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "Privacy Policy",
        "urlSlug": "generic2",
        "externalURL": null,
        "pageView": [{"referenceId": "99a13082-c038-4cd2-9e71-38e57455e9cd", "templateTypeId": 14, "pageType": 14}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "8abbcd01-a4c1-49b8-b86e-d3be7a9c14db",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "Lander Page",
        "urlSlug": "home",
        "externalURL": null,
        "pageView": [{"referenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d", "templateTypeId": 1, "pageType": 1}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "8a82d59a-d8ba-4fa5-813e-d6c179409295",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "Lead Page",
        "urlSlug": "lead",
        "externalURL": null,
        "pageView": [{"referenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472", "templateTypeId": 2, "pageType": 2}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "2fd7784f-58da-4559-bdb4-e2722134100a",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "PageNotFound",
        "urlSlug": "notfound",
        "externalURL": null,
        "pageView": [{"referenceId": "61189c1b-cb98-4a95-92e2-df9a1922cac5", "templateTypeId": 38, "pageType": 38}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "50fa2b55-0746-4dee-8a9b-ea9edefbecf5",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "Product Detail",
        "urlSlug": "product_detail",
        "externalURL": null,
        "pageView": [{"referenceId": "05096934-d33a-494c-b8c6-293979d75fa7", "templateTypeId": 34, "pageType": 34}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "76730c83-299a-4522-a1dc-837fc38fa025",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "Product Detail1",
        "urlSlug": "product_detail1",
        "externalURL": null,
        "pageView": [{"referenceId": "51b6b746-3e7c-4106-b60b-93df49af2078", "templateTypeId": 34, "pageType": 34}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }, {
        "referenceId": "350d5f46-ed70-410e-b423-b85a66d6bafb",
        "splitReferenceId": null,
        "splitEnabled": false,
        "isMembershipRequired": false,
        "title": "Thank You Page",
        "urlSlug": "thank_you",
        "externalURL": null,
        "pageView": [{"referenceId": "8c2f8508-1941-472f-9363-2b541646465c", "templateTypeId": 5, "pageType": 5}],
        "pageProducts": [],
        "pagebillingCycles": [],
        "pageVariants": [],
        "isPageTitle": false,
        "pageProperties": []
      }],
      "disableBadge": false,
      "name": "Store Funnel",
      "whitelabelId": 10,
      "affiliateId": null,
      "isMenuEnabled": true
    },
    "elements": [{
      "elementId": "fkt-button-08a-ba2-821",
      "href": null,
      "status": null,
      "pageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-3e3-d80-b03",
      "href": null,
      "status": null,
      "pageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
      "linkDetails": [{
        "targetPageReferenceId": "8abbcd01-a4c1-49b8-b86e-d3be7a9c14db",
        "targetPageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
        "products": [],
        "urlSlug": "home",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": [{"LinkId": 21244, "Name": "CustomProductTags", "Value": ""}]
      }],
      "products": []
    }, {
      "elementId": "fkt-button-4af-e83-a6f",
      "href": null,
      "status": null,
      "pageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-b21-0a1-8fe",
      "href": null,
      "status": null,
      "pageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-028-094-8cc",
      "href": null,
      "status": null,
      "pageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-5ed-a9c-882",
      "href": null,
      "status": null,
      "pageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-97f-7ac-93a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-9d7-790-91a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-a1b-fbc-aa4",
      "href": null,
      "status": null,
      "pageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-af9-cbd-a38",
      "href": null,
      "status": null,
      "pageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
      "linkDetails": [{
        "targetPageReferenceId": "f6273e83-6c90-4e39-9788-3814a89d0344",
        "targetPageViewReferenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57",
        "products": [],
        "urlSlug": "checkout",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": [{"LinkId": 21157, "Name": "CustomProductTags", "Value": ""}]
      }],
      "products": []
    }, {
      "elementId": "fkt-link-d48-499-8d0",
      "href": null,
      "status": null,
      "pageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-3e3-d80-b03",
      "href": null,
      "status": null,
      "pageViewReferenceId": "168d73d0-3399-4725-9142-8efe3f562b34",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-028-094-8cc",
      "href": null,
      "status": null,
      "pageViewReferenceId": "168d73d0-3399-4725-9142-8efe3f562b34",
      "linkDetails": [{
        "targetPageReferenceId": "9e46f245-6502-4089-ba07-315a9ff25ee4",
        "targetPageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
        "products": [],
        "urlSlug": "generic",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": []
      }],
      "products": []
    }, {
      "elementId": "fkt-link-5ed-a9c-882",
      "href": null,
      "status": null,
      "pageViewReferenceId": "168d73d0-3399-4725-9142-8efe3f562b34",
      "linkDetails": [{
        "targetPageReferenceId": "8a82d59a-d8ba-4fa5-813e-d6c179409295",
        "targetPageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
        "products": [],
        "urlSlug": "lead",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": []
      }],
      "products": []
    }, {
      "elementId": "fkt-link-97f-7ac-93a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "168d73d0-3399-4725-9142-8efe3f562b34",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-9d7-790-91a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "168d73d0-3399-4725-9142-8efe3f562b34",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-a1b-fbc-aa4",
      "href": null,
      "status": null,
      "pageViewReferenceId": "168d73d0-3399-4725-9142-8efe3f562b34",
      "linkDetails": [{
        "targetPageReferenceId": "22ed9553-0d6e-4b76-b594-2ff51b9ed23a",
        "targetPageViewReferenceId": "244cceed-d818-4689-932f-142c9941ffcc",
        "products": [],
        "urlSlug": "generic1",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": []
      }],
      "products": []
    }, {
      "elementId": "fkt-link-af9-cbd-a38",
      "href": null,
      "status": null,
      "pageViewReferenceId": "168d73d0-3399-4725-9142-8efe3f562b34",
      "linkDetails": [{
        "targetPageReferenceId": "f6273e83-6c90-4e39-9788-3814a89d0344",
        "targetPageViewReferenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57",
        "products": [],
        "urlSlug": "checkout",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": []
      }],
      "products": []
    }, {
      "elementId": "fkt-link-d48-499-8d0",
      "href": null,
      "status": null,
      "pageViewReferenceId": "168d73d0-3399-4725-9142-8efe3f562b34",
      "linkDetails": [{
        "targetPageReferenceId": "67f17640-4a63-4614-8585-5381b6c6f5e2",
        "targetPageViewReferenceId": "99a13082-c038-4cd2-9e71-38e57455e9cd",
        "products": [],
        "urlSlug": "generic2",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": []
      }],
      "products": []
    }, {
      "elementId": "fkt-button-3e3-d80-b03",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-063-d84-bb7",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-09e-698-8c8",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-09f-8a6-a09",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-0f0-d89-801",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-2e6-a9f-ac8",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-601-1a0-837",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [{
        "targetPageReferenceId": "50fa2b55-0746-4dee-8a9b-ea9edefbecf5",
        "targetPageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
        "products": [],
        "urlSlug": "product_detail",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": []
      }],
      "products": []
    }, {
      "elementId": "fkt-link-654-ba7-aa6",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-93f-fbd-b32",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-95e-b86-8c6",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-97f-7ac-93a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-9a9-eba-b97",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-9d7-790-91a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-9f3-bba-99f",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-a61-9bf-9bc",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-acf-09a-803",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-af9-cbd-a38",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-b31-393-8a0",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [{
        "targetPageReferenceId": "50fa2b55-0746-4dee-8a9b-ea9edefbecf5",
        "targetPageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
        "products": [],
        "urlSlug": "product_detail",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": []
      }],
      "products": []
    }, {
      "elementId": "fkt-link-cb8-78e-b29",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-cd5-3a1-837",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-d30-99a-b70",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-e2a-4ba-ae8",
      "href": null,
      "status": null,
      "pageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-3e3-d80-b03",
      "href": null,
      "status": null,
      "pageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-5c9-3bb-969",
      "href": null,
      "status": null,
      "pageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-7b1-0ba-bae",
      "href": null,
      "status": null,
      "pageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-028-094-8cc",
      "href": null,
      "status": null,
      "pageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-5ed-a9c-882",
      "href": null,
      "status": null,
      "pageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-97f-7ac-93a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-9d7-790-91a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-a1b-fbc-aa4",
      "href": null,
      "status": null,
      "pageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-af9-cbd-a38",
      "href": null,
      "status": null,
      "pageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-d48-499-8d0",
      "href": null,
      "status": null,
      "pageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-3e3-d80-b03",
      "href": null,
      "status": null,
      "pageViewReferenceId": "61189c1b-cb98-4a95-92e2-df9a1922cac5",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-97f-7ac-93a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "61189c1b-cb98-4a95-92e2-df9a1922cac5",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-9d7-790-91a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "61189c1b-cb98-4a95-92e2-df9a1922cac5",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-af9-cbd-a38",
      "href": null,
      "status": null,
      "pageViewReferenceId": "61189c1b-cb98-4a95-92e2-df9a1922cac5",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-53e-691-944",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-c03-0af-bcf",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-042-5b6-9da",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-250-f93-853",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-5fb-eb3-88c",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-6c9-3b4-9f6",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-800-0a3-aa8",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-933-f94-926",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-a09-99e-bf0",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-acf-19e-a77",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-b73-e8d-96b",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-df0-2bb-a57",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-ea5-986-a0f",
      "href": null,
      "status": null,
      "pageViewReferenceId": "672c43fc-9126-4b59-b1a0-f1c472b3256b",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-aab-993-952",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-d1a-1ae-b22",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-d21-89f-aa6",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-023-a8e-bb4",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-141-d8f-b9b",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-25a-095-956",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-27f-2ae-800",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-314-fae-958",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-458-78a-a6f",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-519-4ba-944",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-56b-181-98d",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-570-a83-821",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-588-9b4-80f",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-602-ea2-87a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-705-289-98a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-782-3a8-8b3",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-7fc-092-b37",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-837-d98-8dd",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-9e6-6af-b04",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-dbc-9ad-ab1",
      "href": null,
      "status": null,
      "pageViewReferenceId": "789e1a96-3eca-4b04-8669-ec95b5be4472",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-786-693-95e",
      "href": null,
      "status": null,
      "pageViewReferenceId": "87218a54-cb07-48d6-9842-8af44d19763c",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-e16-3ac-9cb",
      "href": null,
      "status": null,
      "pageViewReferenceId": "87218a54-cb07-48d6-9842-8af44d19763c",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-05a-482-b05",
      "href": null,
      "status": null,
      "pageViewReferenceId": "87218a54-cb07-48d6-9842-8af44d19763c",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-51b-c80-80a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "87218a54-cb07-48d6-9842-8af44d19763c",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-d48-494-896",
      "href": null,
      "status": null,
      "pageViewReferenceId": "87218a54-cb07-48d6-9842-8af44d19763c",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-717-ba9-a3c",
      "href": null,
      "status": null,
      "pageViewReferenceId": "8c2f8508-1941-472f-9363-2b541646465c",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-e13-a9f-bb7",
      "href": null,
      "status": null,
      "pageViewReferenceId": "8c2f8508-1941-472f-9363-2b541646465c",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-65f-cad-949",
      "href": "",
      "status": null,
      "pageViewReferenceId": "8c2f8508-1941-472f-9363-2b541646465c",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-12c-495-bab",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-242-eab-9bb",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-9f0-7a5-ab7",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-dcc-2b7-ad6",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57",
      "linkDetails": [{
        "targetPageReferenceId": "350d5f46-ed70-410e-b423-b85a66d6bafb",
        "targetPageViewReferenceId": "8c2f8508-1941-472f-9363-2b541646465c",
        "products": [],
        "urlSlug": "thank_you",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": []
      }],
      "products": []
    }, {
      "elementId": "fkt-link-1b0-38f-838",
      "href": "",
      "status": null,
      "pageViewReferenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-52a-2b9-a29",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-65f-cad-949",
      "href": "",
      "status": null,
      "pageViewReferenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-724-390-b09",
      "href": "",
      "status": null,
      "pageViewReferenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-ae5-bbe-9c0",
      "href": "",
      "status": null,
      "pageViewReferenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-f05-abd-b42",
      "href": "",
      "status": null,
      "pageViewReferenceId": "e4a7fb6e-57dc-4df5-bc37-37f1a44f1b57",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-079-a85-a86",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [{
        "targetPageReferenceId": "76730c83-299a-4522-a1dc-837fc38fa025",
        "targetPageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
        "products": [],
        "urlSlug": "product_detail1",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": [{"LinkId": 21183, "Name": "CustomProductTags", "Value": ""}]
      }],
      "products": [480]
    }, {
      "elementId": "fkt-button-0a5-79d-b6f",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [{
        "targetPageReferenceId": "76730c83-299a-4522-a1dc-837fc38fa025",
        "targetPageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
        "products": [],
        "urlSlug": "product_detail1",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": [{"LinkId": 21183, "Name": "CustomProductTags", "Value": ""}]
      }],
      "products": [481]
    }, {
      "elementId": "fkt-button-124-5a8-8c3",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [{
        "targetPageReferenceId": "738e0f7b-6a25-4a33-aa54-e0cdda077140",
        "targetPageViewReferenceId": "2a3fbf6a-1190-4bea-9016-119e5fbfa829",
        "products": [],
        "urlSlug": "catalog",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": []
      }],
      "products": []
    }, {
      "elementId": "fkt-button-227-08a-963",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [{
        "targetPageReferenceId": "50fa2b55-0746-4dee-8a9b-ea9edefbecf5",
        "targetPageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
        "products": [],
        "urlSlug": "product_detail",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": [{"LinkId": 21122, "Name": "CustomProductTags", "Value": ""}]
      }],
      "products": [480]
    }, {
      "elementId": "fkt-button-3e3-d80-b03",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-button-47a-599-854",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [{
        "targetPageReferenceId": "76730c83-299a-4522-a1dc-837fc38fa025",
        "targetPageViewReferenceId": "51b6b746-3e7c-4106-b60b-93df49af2078",
        "products": [],
        "urlSlug": "product_detail1",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": [{"LinkId": 21183, "Name": "CustomProductTags", "Value": ""}]
      }],
      "products": [479]
    }, {
      "elementId": "fkt-button-d2f-4bc-bc4",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [{
        "targetPageReferenceId": "50fa2b55-0746-4dee-8a9b-ea9edefbecf5",
        "targetPageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
        "products": [],
        "urlSlug": "product_detail",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": [{"LinkId": 21122, "Name": "CustomProductTags", "Value": ""}]
      }],
      "products": [479]
    }, {
      "elementId": "fkt-button-fb8-58d-bc4",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [{
        "targetPageReferenceId": "50fa2b55-0746-4dee-8a9b-ea9edefbecf5",
        "targetPageViewReferenceId": "05096934-d33a-494c-b8c6-293979d75fa7",
        "products": [],
        "urlSlug": "product_detail",
        "billingCycleIds": [],
        "isAllProducts": false,
        "previouslyPurchasedProducts": false,
        "customerType": 0,
        "pageVariants": null,
        "countryStates": null,
        "customLinkViewEntities": [{"LinkId": 21122, "Name": "CustomProductTags", "Value": ""}]
      }],
      "products": [481]
    }, {
      "elementId": "fkt-link-028-094-8cc",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-5ed-a9c-882",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-97f-7ac-93a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-9d7-790-91a",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-a1b-fbc-aa4",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-af9-cbd-a38",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [],
      "products": []
    }, {
      "elementId": "fkt-link-d48-499-8d0",
      "href": null,
      "status": null,
      "pageViewReferenceId": "e818e264-5d53-4e3b-a8a9-5505ffd56a4d",
      "linkDetails": [],
      "products": []
    }],
    "isFunnel": true,
    "faviconUrl": "",
    "logoUrl": "https://dev-assets.checkoutchamp.com/dev-assets.funnelkonnekt.com/Funnel/assets/logo/ddd8051a-d53f-4a43-84a8-f8f551f1268a/download.png"
  };
  static campaignJson = {
    "selectedCampaign": {
      "campaignId": 44,
      "dateCreated": "2023-01-30 08:33:51",
      "campaignName": "Xbox",
      "campaignType": "ECOMMERCE",
      "currency": "USD",
      "requireQA": 0,
      "listSalesEntry": 0,
      "captureOnShipment": 0,
      "requireTOS": 0,
      "eSignature": 0,
      "campaignTOS": null,
      "preauthOnly": 0,
      "enableFraudPlugin": 0,
      "insureShipId": 0,
      "insureShipBillerId": 1,
      "insureShipLoadBalancerId": null,
      "defaultShipProfileId": null,
      "externalCampaignId": null,
      "qaPercent": 0,
      "campaignCategoryId": 4,
      "pinlessDebitRoute": 0,
      "prPercent": 0,
      "codOrders": 0,
      "blockPrepaid": 1,
      "blockDebit": 1,
      "blockMastercard": 0,
      "blockVisa": 0,
      "disableExternalPayments": 0,
      "disableRecycleBilling": 0,
      "singleTransaction": 0,
      "bundleFulfillment": 0,
      "blockChargebackBlacklist": 1,
      "couponMax": 6,
      "visible": 1,
      "isLocked": 0,
      "taxServiceId": null,
      "autoTax": 0,
      "upsellWindow": null,
      "maxBundleHours": 15,
      "reOrderDays": 0,
      "currencySymbol": "$",
      "currencyNumber": "840",
      "defaultCouponCode": null,
      "singleTxnGateways": ["AcquiredV2", "Apcopay", "Authorize.netV2", "Braintree", "cardinity", "Cardstream", "Celerispay", "CheckoutV2", "Corvia", "Dummy Gateway", "Easytransac", "Fluid Pay", "Gala Technology", "Gate2Payments", "maverick", "MiCamp", "NMI", "NomuPay", "Oonex", "Open Payment Platform", "PayCom", "Payfirma", "Paynetworx", "Payon Gateway", "PayPal Commerce", "PaysafeDirect", "Paystrax", "Poynt", "Revolv3", "StripeV2", "Swipen", "VantivV2", "Whitelabel Payments", "WithReach", "WorldlineV2", "Worldpay Corporate"],
      "shopPayUrl": "https://extremegadgetz.myshopify.com",
      "products": [{
        "campaignProductId": 233,
        "productName": "Fall Guys",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "MULTI_PAY",
        "finalBillingCycle": 5,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 31,
        "cycle2_price": "60.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 30,
        "cycle3_price": "30.00",
        "cycle3_shipPrice": "0.00",
        "cycle3_isShippable": 0,
        "cycle3_billDelay": 30,
        "trialEnabled": 1,
        "trialType": "STANDARD",
        "trialAuthType": "HOLDTRIALCHARGE",
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 131,
        "clientProductId": null,
        "baseProductName": "Fall Guys",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 131,
        "cycle1_combinationId": 0,
        "cycle2_productId": 131,
        "cycle2_combinationId": 0,
        "cycle3_productId": 131,
        "cycle3_combinationId": 0,
        "cycle4_price": "50.00",
        "cycle4_shipPrice": "0.00",
        "cycle4_isShippable": 0,
        "cycle4_billDelay": 30,
        "cycle4_productId": 131,
        "cycle4_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 15,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": [{
          "comboProductId": 133,
          "comboProductName": "Halo 5",
          "parentProductId": 131,
          "stockQuantity": "0",
          "variants": [{"title": "Base", "variantDetailId": "230", "stockQuantity": "0"}, {
            "title": "Platinum",
            "variantDetailId": "231",
            "stockQuantity": "0"
          }, {"title": "Collector", "variantDetailId": "232", "stockQuantity": "0"}]
        }]
      }, {
        "campaignProductId": 279,
        "productName": "Same Order Product",
        "productType": "OFFER",
        "price": "20.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "MULTI_PAY",
        "finalBillingCycle": 9,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "20.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": "30.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 30,
        "cycle3_price": "40.00",
        "cycle3_shipPrice": "0.00",
        "cycle3_isShippable": 0,
        "cycle3_billDelay": 30,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 131,
        "clientProductId": null,
        "baseProductName": "Fall Guys",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 131,
        "cycle1_combinationId": 0,
        "cycle2_productId": 131,
        "cycle2_combinationId": 0,
        "cycle3_productId": 131,
        "cycle3_combinationId": 0,
        "cycle4_price": "50.00",
        "cycle4_shipPrice": "0.00",
        "cycle4_isShippable": 0,
        "cycle4_billDelay": 30,
        "cycle4_productId": 131,
        "cycle4_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 15,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": [{
          "comboProductId": 133,
          "comboProductName": "Halo 5",
          "parentProductId": 131,
          "stockQuantity": "0",
          "variants": [{"title": "Base", "variantDetailId": "230", "stockQuantity": "0"}, {
            "title": "Platinum",
            "variantDetailId": "231",
            "stockQuantity": "0"
          }, {"title": "Collector", "variantDetailId": "232", "stockQuantity": "0"}]
        }]
      }, {
        "campaignProductId": 281,
        "productName": "MultiPayTests",
        "productType": "OFFER",
        "price": "30.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "MULTI_PAY",
        "finalBillingCycle": 5,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "30.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 131,
        "clientProductId": null,
        "baseProductName": "Fall Guys",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 131,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 15,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": [{
          "comboProductId": 133,
          "comboProductName": "Halo 5",
          "parentProductId": 131,
          "stockQuantity": "0",
          "variants": [{"title": "Base", "variantDetailId": "230", "stockQuantity": "0"}, {
            "title": "Platinum",
            "variantDetailId": "231",
            "stockQuantity": "0"
          }, {"title": "Collector", "variantDetailId": "232", "stockQuantity": "0"}]
        }]
      }, {
        "campaignProductId": 466,
        "productName": "MultiPayProduct",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "9.99",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "MULTI_PAY",
        "finalBillingCycle": 2,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "9.99",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 10,
        "cycle2_price": "169.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 10,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 1,
        "trialType": "STANDARD",
        "trialAuthType": "HOLDTRIALCHARGE",
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 123,
        "clientProductId": null,
        "baseProductName": "DayZ",
        "productSku": null,
        "productDescription": null,
        "productCost": "14.99",
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product123.png",
        "stockQuantity": "0",
        "allowStorePickup": 1,
        "productTags": "buy2",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 123,
        "cycle1_combinationId": 0,
        "cycle2_productId": 123,
        "cycle2_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "9.99",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 4.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 40,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 17.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 3,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "15.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 50,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 467,
        "productName": "MultiPayProduct",
        "productType": "OFFER",
        "price": "9.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "MULTI_PAY",
        "finalBillingCycle": 2,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "9.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 10,
        "cycle2_price": "169.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 10,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 1,
        "trialType": "STANDARD",
        "trialAuthType": "HOLDTRIALCHARGE",
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 123,
        "clientProductId": null,
        "baseProductName": "DayZ",
        "productSku": null,
        "productDescription": null,
        "productCost": "14.99",
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product123.png",
        "stockQuantity": "0",
        "allowStorePickup": 1,
        "productTags": "buy2",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 123,
        "cycle1_combinationId": 0,
        "cycle2_productId": 123,
        "cycle2_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "9.99",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 4.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 40,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 17.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 3,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "15.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 50,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 224,
        "productName": "Game Pass",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": "16.99",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 35,
        "cycle3_price": "19.99",
        "cycle3_shipPrice": "0.00",
        "cycle3_isShippable": 0,
        "cycle3_billDelay": 40,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 121,
        "clientProductId": null,
        "baseProductName": "Game Pass (regular)",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product121.png",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 121,
        "cycle1_combinationId": 0,
        "cycle2_productId": 121,
        "cycle2_combinationId": 0,
        "cycle3_productId": 121,
        "cycle3_combinationId": 0,
        "cycle4_price": "30.00",
        "cycle4_shipPrice": "0.00",
        "cycle4_isShippable": 0,
        "cycle4_billDelay": 45,
        "cycle4_productId": 121,
        "cycle4_combinationId": 0,
        "cycle5_price": "30.00",
        "cycle5_shipPrice": "0.00",
        "cycle5_isShippable": 0,
        "cycle5_billDelay": 45,
        "cycle5_productId": 121,
        "cycle5_combinationId": 0,
        "cycle6_price": "30.00",
        "cycle6_shipPrice": "0.00",
        "cycle6_isShippable": 0,
        "cycle6_billDelay": 45,
        "cycle6_productId": 121,
        "cycle6_combinationId": 0,
        "cycle7_price": "30.00",
        "cycle7_shipPrice": "0.00",
        "cycle7_isShippable": 0,
        "cycle7_billDelay": 45,
        "cycle7_productId": 121,
        "cycle7_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 226,
        "productName": "Game Pass Ultimate",
        "productType": "UPSALE",
        "price": "20.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "20.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 124,
        "clientProductId": null,
        "baseProductName": "Club Pass Ultimate",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "cycle1_productId": 124,
        "cycle1_combinationId": 0,
        "variants": [{
          "title": "xbox",
          "productSku": null,
          "price": "10.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 359,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": 30,
          "variantName1": "type",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "xbox",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 5,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "pc",
          "productSku": null,
          "price": "15.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 360,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "type",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "pc",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 7.5,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "all",
          "productSku": null,
          "price": "40.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 361,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": 30,
          "variantName1": "type",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "all",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 20,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 229,
        "productName": "Game Pass PC",
        "productType": "OFFER",
        "price": "18.00",
        "shippingPrice": "15.00",
        "compareAtPrice": "0.00",
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "18.00",
        "cycle1_shipPrice": "15.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": "8.00",
        "cycle2_shipPrice": "10.00",
        "cycle2_isShippable": 1,
        "cycle2_billDelay": 30,
        "cycle3_price": "50.00",
        "cycle3_shipPrice": "0.00",
        "cycle3_isShippable": 0,
        "cycle3_billDelay": 30,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 127,
        "clientProductId": null,
        "baseProductName": "Game Pass PC",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 127,
        "cycle1_combinationId": 0,
        "cycle2_productId": 127,
        "cycle2_combinationId": 0,
        "cycle3_productId": 127,
        "cycle3_combinationId": 0,
        "cycle4_price": "50.00",
        "cycle4_shipPrice": "0.00",
        "cycle4_isShippable": 0,
        "cycle4_billDelay": 30,
        "cycle4_productId": 127,
        "cycle4_combinationId": 0,
        "cycle5_price": "60.00",
        "cycle5_shipPrice": "0.00",
        "cycle5_isShippable": 0,
        "cycle5_billDelay": 30,
        "cycle5_productId": 127,
        "cycle5_combinationId": 0,
        "cycle6_price": "60.00",
        "cycle6_shipPrice": "0.00",
        "cycle6_isShippable": 0,
        "cycle6_billDelay": 30,
        "cycle6_productId": 127,
        "cycle6_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 230,
        "productName": "New Games Sub",
        "productType": "OFFER",
        "price": "30.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "30.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": "35.55",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 1,
        "cycle2_billDelay": 45,
        "cycle3_price": "45.00",
        "cycle3_shipPrice": "0.00",
        "cycle3_isShippable": 1,
        "cycle3_billDelay": 62,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 128,
        "clientProductId": null,
        "baseProductName": "New Games Sub",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 128,
        "cycle1_combinationId": 0,
        "cycle2_productId": 128,
        "cycle2_combinationId": 0,
        "cycle3_productId": 128,
        "cycle3_combinationId": 0,
        "cycle4_price": "50.55",
        "cycle4_shipPrice": "0.00",
        "cycle4_isShippable": 1,
        "cycle4_billDelay": 75,
        "cycle4_productId": 128,
        "cycle4_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 15,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 247,
        "productName": "Recurring Replay Combo",
        "productType": "OFFER",
        "price": "15.99",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": null,
        "billerName": null,
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": 1,
        "loadBalancerName": "Main Test",
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.99",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 139,
        "clientProductId": null,
        "baseProductName": "Recurring Replay Combo Upsell offer",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 139,
        "cycle1_combinationId": 134,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 8,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 248,
        "productName": "Recurring Replay Combo",
        "productType": "UPSALE",
        "price": "19.99",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "19.99",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 139,
        "clientProductId": null,
        "baseProductName": "Recurring Replay Combo Upsell offer",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 139,
        "cycle1_combinationId": 134,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 8,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 249,
        "productName": "Rare Replay-Combination",
        "productType": "UPSALE",
        "price": "19.99",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "19.99",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 134,
        "clientProductId": null,
        "baseProductName": "Recurring Replay Upsell",
        "productSku": null,
        "productDescription": "Rare Replay-Combination",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 134,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 30,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 49.79,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": [{
          "comboProductId": 136,
          "comboProductName": "Perfect Dark",
          "parentProductId": 134,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 133,
          "comboProductName": "Halo 5",
          "parentProductId": 134,
          "stockQuantity": "0",
          "variants": [{"title": "Base", "variantDetailId": "230", "stockQuantity": "0"}, {
            "title": "Platinum",
            "variantDetailId": "231",
            "stockQuantity": "0"
          }, {"title": "Collector", "variantDetailId": "232", "stockQuantity": "0"}]
        }, {
          "comboProductId": 132,
          "comboProductName": "Gears of War 5",
          "parentProductId": 134,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 135,
          "comboProductName": "Banjo Kazooie",
          "parentProductId": 134,
          "stockQuantity": "0",
          "variants": []
        }]
      }, {
        "campaignProductId": 252,
        "productName": "Combo Product w/ multi variant product",
        "productType": "UPSALE",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 138,
        "clientProductId": null,
        "baseProductName": "MV Prod",
        "productSku": null,
        "productDescription": "Combo Product w/ multi variant prod",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 138,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": [{
          "comboProductId": 137,
          "comboProductName": "Xbox T-Shirt",
          "parentProductId": 138,
          "stockQuantity": "0",
          "variants": [{
            "title": "Black / Xbox / small",
            "variantDetailId": "269",
            "stockQuantity": "0"
          }, {
            "title": "Black / Xbox / medium",
            "variantDetailId": "270",
            "stockQuantity": "0"
          }, {
            "title": "Black / Xbox / large",
            "variantDetailId": "271",
            "stockQuantity": "0"
          }, {
            "title": "Black / One / small",
            "variantDetailId": "272",
            "stockQuantity": "0"
          }, {
            "title": "Black / One / medium",
            "variantDetailId": "273",
            "stockQuantity": "0"
          }, {
            "title": "Black / One / large",
            "variantDetailId": "274",
            "stockQuantity": "0"
          }, {
            "title": "Black / Series / small",
            "variantDetailId": "275",
            "stockQuantity": "0"
          }, {
            "title": "Black / Series / medium",
            "variantDetailId": "276",
            "stockQuantity": "0"
          }, {
            "title": "Black / Series / large",
            "variantDetailId": "277",
            "stockQuantity": "0"
          }, {
            "title": "White / Xbox / small",
            "variantDetailId": "278",
            "stockQuantity": "0"
          }, {
            "title": "White / Xbox / medium",
            "variantDetailId": "279",
            "stockQuantity": "0"
          }, {
            "title": "White / Xbox / large",
            "variantDetailId": "280",
            "stockQuantity": "0"
          }, {
            "title": "White / One / small",
            "variantDetailId": "281",
            "stockQuantity": "0"
          }, {
            "title": "White / One / medium",
            "variantDetailId": "282",
            "stockQuantity": "0"
          }, {
            "title": "White / One / large",
            "variantDetailId": "283",
            "stockQuantity": "0"
          }, {
            "title": "White / Series / small",
            "variantDetailId": "284",
            "stockQuantity": "0"
          }, {
            "title": "White / Series / medium",
            "variantDetailId": "285",
            "stockQuantity": "0"
          }, {
            "title": "White / Series / large",
            "variantDetailId": "286",
            "stockQuantity": "0"
          }, {
            "title": "Green / Xbox / small",
            "variantDetailId": "287",
            "stockQuantity": "0"
          }, {
            "title": "Green / Xbox / medium",
            "variantDetailId": "288",
            "stockQuantity": "0"
          }, {
            "title": "Green / Xbox / large",
            "variantDetailId": "289",
            "stockQuantity": "0"
          }, {
            "title": "Green / One / small",
            "variantDetailId": "290",
            "stockQuantity": "0"
          }, {
            "title": "Green / One / medium",
            "variantDetailId": "291",
            "stockQuantity": "0"
          }, {
            "title": "Green / One / large",
            "variantDetailId": "292",
            "stockQuantity": "0"
          }, {
            "title": "Green / Series / small",
            "variantDetailId": "293",
            "stockQuantity": "0"
          }, {
            "title": "Green / Series / medium",
            "variantDetailId": "294",
            "stockQuantity": "0"
          }, {"title": "Green / Series / large", "variantDetailId": "295", "stockQuantity": "0"}]
        }, {
          "comboProductId": 133,
          "comboProductName": "Halo 5",
          "parentProductId": 138,
          "stockQuantity": "0",
          "variants": [{"title": "Base", "variantDetailId": "230", "stockQuantity": "0"}, {
            "title": "Platinum",
            "variantDetailId": "231",
            "stockQuantity": "0"
          }, {"title": "Collector", "variantDetailId": "232", "stockQuantity": "0"}]
        }, {
          "comboProductId": 123,
          "comboProductName": "DayZ",
          "parentProductId": 138,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 138,
          "comboProductName": "MV Prod",
          "parentProductId": 138,
          "stockQuantity": "0",
          "variants": []
        }]
      }, {
        "campaignProductId": 253,
        "productName": "(141) game pass trial",
        "productType": "OFFER",
        "price": "5.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "5.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 1,
        "trialType": "STANDARD",
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 141,
        "clientProductId": null,
        "baseProductName": "game pass trial",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 141,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 258,
        "productName": "Nintendo Super",
        "productType": "OFFER",
        "price": "35.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "35.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": "45.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 30,
        "cycle3_price": "28.00",
        "cycle3_shipPrice": "0.00",
        "cycle3_isShippable": 0,
        "cycle3_billDelay": 30,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 142,
        "clientProductId": null,
        "baseProductName": "Nintendo plus",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 18,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 142,
        "cycle1_combinationId": 0,
        "cycle2_productId": 142,
        "cycle2_combinationId": 0,
        "cycle3_productId": 142,
        "cycle3_combinationId": 0,
        "cycle4_price": "18.00",
        "cycle4_shipPrice": "0.00",
        "cycle4_isShippable": 0,
        "cycle4_billDelay": 30,
        "cycle4_productId": 142,
        "cycle4_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 259,
        "productName": "Xbox Live Silver",
        "productType": "OFFER",
        "price": "29.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "29.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": "38.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 1,
        "cycle2_billDelay": 30,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 141,
        "clientProductId": null,
        "baseProductName": "game pass trial",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 141,
        "cycle1_combinationId": 0,
        "cycle2_productId": 141,
        "cycle2_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 260,
        "productName": "Xbox Live Gold",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 21,
        "cycle2_price": "90.00",
        "cycle2_shipPrice": "6.95",
        "cycle2_isShippable": 1,
        "cycle2_billDelay": 90,
        "cycle3_price": "90.00",
        "cycle3_shipPrice": "6.95",
        "cycle3_isShippable": 1,
        "cycle3_billDelay": 90,
        "trialEnabled": 1,
        "trialType": "STANDARD",
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 141,
        "clientProductId": null,
        "baseProductName": "game pass trial",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 141,
        "cycle1_combinationId": 0,
        "cycle2_productId": 141,
        "cycle2_combinationId": 0,
        "cycle3_productId": 141,
        "cycle3_combinationId": 0,
        "cycle4_price": "90.00",
        "cycle4_shipPrice": "6.95",
        "cycle4_isShippable": 1,
        "cycle4_billDelay": 90,
        "cycle4_productId": 141,
        "cycle4_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 269,
        "productName": "(153) prorate Membership tests",
        "productType": "OFFER",
        "price": "60.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 23,
        "billerName": "New Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "60.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 153,
        "clientProductId": null,
        "baseProductName": "prorate Membership tests",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "13",
        "productCategoryName": "Subscriptions and Memberships",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 153,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 270,
        "productName": "(154) prorate membership upgrade",
        "productType": "OFFER",
        "price": "10.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 23,
        "billerName": "New Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "10.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 154,
        "clientProductId": null,
        "baseProductName": "prorate membership upgrade",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "13",
        "productCategoryName": "Subscriptions and Memberships",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 154,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 271,
        "productName": "(153) prorate Membership tests upgrade",
        "productType": "OFFER",
        "price": "100.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 23,
        "billerName": "New Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "100.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 153,
        "clientProductId": null,
        "baseProductName": "prorate Membership tests",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "13",
        "productCategoryName": "Subscriptions and Memberships",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 153,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 272,
        "productName": "(154) prorate membership upgrade",
        "productType": "UPSALE",
        "price": "100.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "100.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 154,
        "clientProductId": null,
        "baseProductName": "prorate membership upgrade",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "13",
        "productCategoryName": "Subscriptions and Memberships",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 154,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 273,
        "productName": "prorate Membership tests 500",
        "productType": "OFFER",
        "price": "500.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 24,
        "billerName": "Dummy",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "500.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 153,
        "clientProductId": null,
        "baseProductName": "prorate Membership tests",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "13",
        "productCategoryName": "Subscriptions and Memberships",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 153,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 275,
        "productName": "(153) prorate Membership tests",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 23,
        "billerName": "New Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": "15.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 30,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 1,
        "trialType": "STANDARD",
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 153,
        "clientProductId": null,
        "baseProductName": "prorate Membership tests",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "13",
        "productCategoryName": "Subscriptions and Memberships",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 153,
        "cycle1_combinationId": 0,
        "cycle2_productId": 153,
        "cycle2_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 280,
        "productName": "Monthly Game Pass Ultimate",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 124,
        "clientProductId": null,
        "baseProductName": "Club Pass Ultimate",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "cycle1_productId": 124,
        "cycle1_combinationId": 0,
        "variants": [{
          "title": "xbox",
          "productSku": null,
          "price": "10.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 359,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": 30,
          "variantName1": "type",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "xbox",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 5,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "pc",
          "productSku": null,
          "price": "15.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 360,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "type",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "pc",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 7.5,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "all",
          "productSku": null,
          "price": "40.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 361,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": 30,
          "variantName1": "type",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "all",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 20,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 319,
        "productName": "(184) nommembership",
        "productType": "OFFER",
        "price": "60.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "60.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 184,
        "clientProductId": null,
        "baseProductName": "nommembership",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "18",
        "productCategoryName": "Member Pricing",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 184,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 30,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 320,
        "productName": "performance upgrade",
        "productType": "OFFER",
        "price": "200.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "200.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 121,
        "clientProductId": null,
        "baseProductName": "Game Pass (regular)",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product121.png",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 121,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 322,
        "productName": "(178) Coffee Addict Membership",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 23,
        "billerName": "New Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 178,
        "clientProductId": null,
        "baseProductName": "Coffee Addict Membership",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "14",
        "productCategoryName": "Templates",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 24,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 178,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 323,
        "productName": "Bundle Variant",
        "productType": "OFFER",
        "price": "18.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "18.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 185,
        "clientProductId": null,
        "baseProductName": "Bundle Variant",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 1,
        "bundleProductQty": 8,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "14",
        "productCategoryName": "Templates",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "cycle1_productId": 185,
        "cycle1_combinationId": 0,
        "variants": [{
          "title": "Choc",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 380,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Flavor",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Choc",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Van",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 381,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Flavor",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Van",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Straw",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 382,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Flavor",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Straw",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 9,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 368,
        "productName": "trial product",
        "productType": "OFFER",
        "price": "10.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "10.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 14,
        "cycle2_price": "15.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 30,
        "cycle3_price": "15.00",
        "cycle3_shipPrice": "0.00",
        "cycle3_isShippable": 0,
        "cycle3_billDelay": 30,
        "trialEnabled": 1,
        "trialType": "STANDARD",
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 92,
        "clientProductId": null,
        "baseProductName": "Crystal Hair Eraser",
        "productSku": null,
        "productDescription": "\n&lt;meta charset=UTF-8&gt;\\n&lt;p data-mce-fragment=1&gt;&lt;strong data-mce-fragment=1&gt;If you’re tired of razor cuts, painful waxing or expensive lasers — our hair eraser is for you!&lt;/strong&gt;&lt;/p&gt;\\n&lt;p data-mce-fragment=1&gt;",
        "productCost": null,
        "shippingCost": null,
        "weight": "0.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "10",
        "productCategoryName": "extremegadgetz.myshopify.com",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": "7253313159357",
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": 184,
        "externalVariantDetailId": "42167283777725",
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 92,
        "cycle1_combinationId": 0,
        "cycle2_productId": 92,
        "cycle2_combinationId": 0,
        "cycle3_productId": 92,
        "cycle3_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 383,
        "productName": "16 in One EDC Wrench",
        "productType": "OFFER",
        "price": "30.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 23,
        "billerName": "New Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "30.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 88,
        "clientProductId": null,
        "baseProductName": "16 in One EDC Wrench",
        "productSku": null,
        "productDescription": "16 in One EDC Wrench Outdoor Stainless Steel EDC Gadget Outdoor Tactical EDC Tool Bicycle Adjustable Wrench Multi-function Tool",
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "10",
        "productCategoryName": "extremegadgetz.myshopify.com",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": "6633353183421",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0557/8814/2781/products/product-image-1718664644.jpg",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 1,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "cycle1_productId": 88,
        "cycle1_combinationId": 0,
        "variants": [{
          "title": "Black",
          "productSku": "44368345-orange-united-states",
          "price": "20.00",
          "shippingPrice": null,
          "compareAtPrice": "15.00",
          "variantDetailId": 160,
          "externalVariantDetailId": "39534945796285",
          "isOutOfStock": 0,
          "weight": "1.000",
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Black",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 994,
          "imageUrl": "https://cdn.shopify.com/s/files/1/0557/8814/2781/products/product-image-1718664658.jpg",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 10,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 15,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 384,
        "productName": "Super Cool Sunglasses",
        "productType": "OFFER",
        "price": "30.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 23,
        "billerName": "New Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "30.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": null,
        "clientProductId": null,
        "baseProductName": null,
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": null,
        "bundleProductQty": null,
        "productQty": null,
        "campaignProductQty": null,
        "productCategoryId": null,
        "productCategoryName": null,
        "isProductCombo": null,
        "fulfillmentCycleType": null,
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": null,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": null,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 53,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 15,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 387,
        "productName": "MW2 Combo Offer",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 122,
        "clientProductId": null,
        "baseProductName": "MW2 Combo",
        "productSku": null,
        "productDescription": "MW2 Combo Offer",
        "productCost": "43.00",
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "game,shooter",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "cycle1_productId": 122,
        "cycle1_combinationId": 0,
        "variants": [{
          "title": "Base",
          "productSku": null,
          "price": "60.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 228,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Option",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Base",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 30,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "Platnum",
          "productSku": null,
          "price": "80.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 229,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Option",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Platnum",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 40,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "15.00",
          "price": 12.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 12.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": [{
          "comboProductId": 127,
          "comboProductName": "Game Pass PC",
          "parentProductId": 122,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 132,
          "comboProductName": "Gears of War 5",
          "parentProductId": 122,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 131,
          "comboProductName": "Fall Guys",
          "parentProductId": 122,
          "stockQuantity": "0",
          "variants": []
        }]
      }, {
        "campaignProductId": 389,
        "productName": "subandsave  rec",
        "productType": "OFFER",
        "price": "10.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "10.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 198,
        "clientProductId": null,
        "baseProductName": "subandsave",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 198,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 400,
        "productName": "(218) CRM-6646",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 218,
        "clientProductId": null,
        "baseProductName": "CRM-6646",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 218,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 408,
        "productName": "(123) DayZ",
        "productType": "OFFER",
        "price": "80.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "80.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 123,
        "clientProductId": null,
        "baseProductName": "DayZ",
        "productSku": null,
        "productDescription": null,
        "productCost": "14.99",
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product123.png",
        "stockQuantity": "0",
        "allowStorePickup": 1,
        "productTags": "buy2",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 123,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "9.99",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 4.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 40,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 17.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 3,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "15.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 50,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 409,
        "productName": "Game Pass",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 220,
        "clientProductId": "THEGAMEPASS",
        "baseProductName": "Game Pass Sub and Save example",
        "productSku": "THEBESTGAMEPASS",
        "productDescription": "Play Games from the Cloud — Discover Your Next Favorite Game, Plus EA Play + Same Day Releases. Join Now. Play Brand New Games Day 1 on Console, PC, and Mobile from Xbox Game Studios and More. Palworld. Join Xbox Game Pass. Grounded. Monster Hunter Rise. Hello Neighbor 2. Valheim.",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product220.png",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 220,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 410,
        "productName": "Game Pass Ultimate",
        "productType": "OFFER",
        "price": "20.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "20.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 220,
        "clientProductId": "THEGAMEPASS",
        "baseProductName": "Game Pass Sub and Save example",
        "productSku": "THEBESTGAMEPASS",
        "productDescription": "Play Games from the Cloud — Discover Your Next Favorite Game, Plus EA Play + Same Day Releases. Join Now. Play Brand New Games Day 1 on Console, PC, and Mobile from Xbox Game Studios and More. Palworld. Join Xbox Game Pass. Grounded. Monster Hunter Rise. Hello Neighbor 2. Valheim.",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/campaignProduct410.png",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 220,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 441,
        "productName": "Game Pass Variants",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 222,
        "clientProductId": null,
        "baseProductName": "Game Pass Variants",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product222.png",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "cycle1_productId": 222,
        "cycle1_combinationId": 0,
        "variants": [{
          "title": "xbox / monthly",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 418,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": "Cycle",
          "variantName3": null,
          "variantOptionName1": "xbox",
          "variantOptionName2": "monthly",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "https://vaimages.konnektive.com/chriscompany/product_variant_222_418.png"
        }, {
          "title": "xbox / bi-annual",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 419,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": "Cycle",
          "variantName3": null,
          "variantOptionName1": "xbox",
          "variantOptionName2": "bi-annual",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "https://vaimages.konnektive.com/chriscompany/product_variant_222_419.png"
        }, {
          "title": "xbox / annual",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 420,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": "Cycle",
          "variantName3": null,
          "variantOptionName1": "xbox",
          "variantOptionName2": "annual",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "https://vaimages.konnektive.com/chriscompany/product_variant_222_420.png"
        }, {
          "title": "pc / monthly",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 421,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": "Cycle",
          "variantName3": null,
          "variantOptionName1": "pc",
          "variantOptionName2": "monthly",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "https://vaimages.konnektive.com/chriscompany/product_variant_222_421.png"
        }, {
          "title": "pc / bi-annual",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 422,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": "Cycle",
          "variantName3": null,
          "variantOptionName1": "pc",
          "variantOptionName2": "bi-annual",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "https://vaimages.konnektive.com/chriscompany/product_variant_222_422.png"
        }, {
          "title": "pc / annual",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 423,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": "Cycle",
          "variantName3": null,
          "variantOptionName1": "pc",
          "variantOptionName2": "annual",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "https://vaimages.konnektive.com/chriscompany/product_variant_222_423.png"
        }, {
          "title": "ultimate / monthly",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 424,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": "Cycle",
          "variantName3": null,
          "variantOptionName1": "ultimate",
          "variantOptionName2": "monthly",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "https://vaimages.konnektive.com/chriscompany/product_variant_222_424.png"
        }, {
          "title": "ultimate / bi-annual",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 425,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": "Cycle",
          "variantName3": null,
          "variantOptionName1": "ultimate",
          "variantOptionName2": "bi-annual",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "https://vaimages.konnektive.com/chriscompany/product_variant_222_425.png"
        }, {
          "title": "ultimate / annual",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 426,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": "Cycle",
          "variantName3": null,
          "variantOptionName1": "ultimate",
          "variantOptionName2": "annual",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "https://vaimages.konnektive.com/chriscompany/product_variant_222_426.png"
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 444,
        "productName": "Sub test",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "30.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "30.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 225,
        "clientProductId": null,
        "baseProductName": "Sub test",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 225,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "30.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "16.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "16.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "30.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 445,
        "productName": "Sub test 2",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "16.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "16.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": "15.00",
        "cycle2_shipPrice": "123.00",
        "cycle2_isShippable": 1,
        "cycle2_billDelay": 30,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 225,
        "clientProductId": null,
        "baseProductName": "Sub test",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 225,
        "cycle1_combinationId": 0,
        "cycle2_productId": 225,
        "cycle2_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "30.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "16.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "16.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "30.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 446,
        "productName": "Sub test 3",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "16.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "16.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": "15.00",
        "cycle2_shipPrice": "90.00",
        "cycle2_isShippable": 1,
        "cycle2_billDelay": 30,
        "cycle3_price": "15.00",
        "cycle3_shipPrice": "0.00",
        "cycle3_isShippable": 1,
        "cycle3_billDelay": 30,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 225,
        "clientProductId": null,
        "baseProductName": "Sub test",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 225,
        "cycle1_combinationId": 0,
        "cycle2_productId": 225,
        "cycle2_combinationId": 0,
        "cycle3_productId": 225,
        "cycle3_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "30.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "16.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "16.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "30.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 447,
        "productName": "Sub test 4",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "30.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "30.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": "20.00",
        "cycle2_shipPrice": "18.00",
        "cycle2_isShippable": 1,
        "cycle2_billDelay": 30,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 225,
        "clientProductId": null,
        "baseProductName": "Sub test",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 225,
        "cycle1_combinationId": 0,
        "cycle2_productId": 225,
        "cycle2_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "30.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "16.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "16.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "30.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 449,
        "productName": "Game Pass (PG TEST)",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 124,
        "clientProductId": null,
        "baseProductName": "Club Pass Ultimate",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "cycle1_productId": 124,
        "cycle1_combinationId": 0,
        "variants": [{
          "title": "xbox",
          "productSku": null,
          "price": "10.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 359,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": 30,
          "variantName1": "type",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "xbox",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 5,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "pc",
          "productSku": null,
          "price": "15.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 360,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "type",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "pc",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 7.5,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "all",
          "productSku": null,
          "price": "40.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 361,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": 30,
          "variantName1": "type",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "all",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 20,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 450,
        "productName": "Game Pass (trial)",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": "15.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 30,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 1,
        "trialType": "STANDARD",
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 121,
        "clientProductId": null,
        "baseProductName": "Game Pass (regular)",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product121.png",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 121,
        "cycle1_combinationId": 0,
        "cycle2_productId": 121,
        "cycle2_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 453,
        "productName": "Sub Product",
        "productType": "OFFER",
        "price": "5.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "5.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 227,
        "clientProductId": null,
        "baseProductName": "Sub Product",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 227,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 2.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 457,
        "productName": "One Go Trial",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": "15.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 30,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 1,
        "trialType": "STANDARD",
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 121,
        "clientProductId": null,
        "baseProductName": "Game Pass (regular)",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product121.png",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 121,
        "cycle1_combinationId": 0,
        "cycle2_productId": 228,
        "cycle2_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 459,
        "productName": "(229) cycle2misprice",
        "productType": "OFFER",
        "price": "5.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 15,
        "billerName": "Affirm",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": 2,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "5.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 1,
        "cycle2_price": "10.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 1,
        "cycle2_billDelay": 2,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 229,
        "clientProductId": null,
        "baseProductName": "cycle2misprice",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 229,
        "cycle1_combinationId": 0,
        "cycle2_productId": 229,
        "cycle2_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 2.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 2.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 460,
        "productName": "cycle2mispriceAT$0",
        "productType": "OFFER",
        "price": "5.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": 2,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "5.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 1,
        "cycle2_price": "10.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 2,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 229,
        "clientProductId": null,
        "baseProductName": "cycle2misprice",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 229,
        "cycle1_combinationId": 0,
        "cycle2_productId": 229,
        "cycle2_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 2.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 2.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 461,
        "productName": "Base Sub",
        "productType": "OFFER",
        "price": "30.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "30.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 230,
        "clientProductId": null,
        "baseProductName": "Base Sub",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": 12,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 230,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 15,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 463,
        "productName": "Game Pass S Tier",
        "productType": "OFFER",
        "price": "50.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "50.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": "16.99",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 35,
        "cycle3_price": "19.99",
        "cycle3_shipPrice": "0.00",
        "cycle3_isShippable": 0,
        "cycle3_billDelay": 40,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 121,
        "clientProductId": null,
        "baseProductName": "Game Pass (regular)",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product121.png",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 121,
        "cycle1_combinationId": 0,
        "cycle2_productId": 121,
        "cycle2_combinationId": 0,
        "cycle3_productId": 121,
        "cycle3_combinationId": 0,
        "cycle4_price": "30.00",
        "cycle4_shipPrice": "0.00",
        "cycle4_isShippable": 0,
        "cycle4_billDelay": 45,
        "cycle4_productId": 121,
        "cycle4_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 464,
        "productName": "game pass trial",
        "productType": "OFFER",
        "price": "5.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "5.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 3,
        "cycle2_price": "10.00",
        "cycle2_shipPrice": "0.00",
        "cycle2_isShippable": 0,
        "cycle2_billDelay": 30,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 141,
        "clientProductId": null,
        "baseProductName": "game pass trial",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 141,
        "cycle1_combinationId": 0,
        "cycle2_productId": 141,
        "cycle2_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 471,
        "productName": "sub and save (recurring)",
        "productType": "OFFER",
        "price": "40.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "40.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 235,
        "clientProductId": null,
        "baseProductName": "sub and save",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 235,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 20,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 25,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 475,
        "productName": "Demo Club",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 239,
        "clientProductId": null,
        "baseProductName": "Demo Club",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": 43,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 239,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 478,
        "productName": "Blue T-Shirt Subscription",
        "productType": "OFFER",
        "price": "20.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "20.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 240,
        "clientProductId": null,
        "baseProductName": "Blue T-Shirt",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 240,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 15,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 482,
        "productName": "Classic White Polo (monthly)",
        "productType": "OFFER",
        "price": "15.99",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.99",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 241,
        "clientProductId": null,
        "baseProductName": "Classic White Polo",
        "productSku": null,
        "productDescription": "Wonderful white polo made of a cotton polyester blend",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "23",
        "productCategoryName": "Store Funnel",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product241.jpeg",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "polo,shirt",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "cycle1_productId": 241,
        "cycle1_combinationId": 0,
        "variants": [{
          "title": "sm",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 463,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Size",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "sm",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "med",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 464,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Size",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "med",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "lg",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 465,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Size",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "lg",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 8,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 483,
        "productName": "Classic Polo (monthly)",
        "productType": "OFFER",
        "price": "23.99",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "23.99",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 242,
        "clientProductId": null,
        "baseProductName": "Classic Polo",
        "productSku": null,
        "productDescription": "Wonderful color polo made of a cotton polyester blend",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "23",
        "productCategoryName": "Store Funnel",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product242.jpeg",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "polo,shirt",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "cycle1_productId": 242,
        "cycle1_combinationId": 0,
        "variants": [{
          "title": "grey / sm",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 439,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "grey",
          "variantOptionName2": "sm",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "grey / med",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 440,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "grey",
          "variantOptionName2": "med",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "grey / lg",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 441,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "grey",
          "variantOptionName2": "lg",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "blue / sm",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 442,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "blue",
          "variantOptionName2": "sm",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "blue / med",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 443,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "blue",
          "variantOptionName2": "med",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "blue / lg",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 444,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "blue",
          "variantOptionName2": "lg",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "burgundy / sm",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 445,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "burgundy",
          "variantOptionName2": "sm",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "burgundy / med",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 446,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "burgundy",
          "variantOptionName2": "med",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "burgundy / lg",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 447,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "burgundy",
          "variantOptionName2": "lg",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "egg shell / sm",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 448,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "egg shell",
          "variantOptionName2": "sm",
          "variantOptionName3": null,
          "variantOptionSequence1": 4,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "egg shell / med",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 449,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "egg shell",
          "variantOptionName2": "med",
          "variantOptionName3": null,
          "variantOptionSequence1": 4,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "egg shell / lg",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 450,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "egg shell",
          "variantOptionName2": "lg",
          "variantOptionName3": null,
          "variantOptionSequence1": 4,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 12,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 12.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 484,
        "productName": "Graphic T-Shirt (monthly)",
        "productType": "OFFER",
        "price": "18.99",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "18.99",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 244,
        "clientProductId": null,
        "baseProductName": "Graphic T-Shirt",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "23",
        "productCategoryName": "Store Funnel",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product244.jpeg",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "tee,shirt",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 244,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 9.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 11.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 487,
        "productName": "(119) Member Product",
        "productType": "OFFER",
        "price": "10.00",
        "shippingPrice": "2.00",
        "compareAtPrice": null,
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "10.00",
        "cycle1_shipPrice": "2.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 119,
        "clientProductId": null,
        "baseProductName": "Member Product",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": 1,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": 43,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 119,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 489,
        "productName": "COMBO TEST",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "RECURRING",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": 30,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 246,
        "clientProductId": null,
        "baseProductName": "COMBO TEST",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "cycle1_productId": 246,
        "cycle1_combinationId": 0,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 223,
        "productName": "Main Offer",
        "productType": "OFFER",
        "price": "25.00",
        "shippingPrice": "15.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "25.00",
        "cycle1_shipPrice": "15.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 122,
        "clientProductId": null,
        "baseProductName": "MW2 Combo",
        "productSku": null,
        "productDescription": "MW2 Combo Offer",
        "productCost": "43.00",
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "game,shooter",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": "54545454",
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "Base",
          "productSku": null,
          "price": "60.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 228,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Option",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Base",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 30,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "Platnum",
          "productSku": null,
          "price": "80.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 229,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Option",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Platnum",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 40,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "15.00",
          "price": 12.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 12.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": [{
          "comboProductId": 127,
          "comboProductName": "Game Pass PC",
          "parentProductId": 122,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 132,
          "comboProductName": "Gears of War 5",
          "parentProductId": 122,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 131,
          "comboProductName": "Fall Guys",
          "parentProductId": 122,
          "stockQuantity": "0",
          "variants": []
        }]
      }, {
        "campaignProductId": 225,
        "productName": "DayZ",
        "productType": "OFFER",
        "price": "35.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "100.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "35.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 123,
        "clientProductId": null,
        "baseProductName": "DayZ",
        "productSku": null,
        "productDescription": null,
        "productCost": "14.99",
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product123.png",
        "stockQuantity": "0",
        "allowStorePickup": 1,
        "productTags": "buy2",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "9.99",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 4.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 40,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 17.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 3,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "15.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 50,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 227,
        "productName": "MW2 Deluxe Edition",
        "productType": "UPSALE",
        "price": "80.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "80.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 125,
        "clientProductId": null,
        "baseProductName": "MW2 Deluxe Edition",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 40,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 228,
        "productName": "DayZ w/ Livonia DLC",
        "productType": "UPSALE",
        "price": "40.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "40.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 126,
        "clientProductId": null,
        "baseProductName": "DayZ w/ Livonia DLC",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 20,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 234,
        "productName": "Gears of War 5",
        "productType": "OFFER",
        "price": "60.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "60.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 132,
        "clientProductId": null,
        "baseProductName": "Gears of War 5",
        "productSku": "dsf52as1df3",
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": "3.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 30,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 235,
        "productName": "Halo 5",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 133,
        "clientProductId": null,
        "baseProductName": "Halo 5",
        "productSku": "d1f3sd1fa3s",
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "buy2",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "Base",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 230,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Base",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Platinum",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 231,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Platinum",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Collector",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 232,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Collector",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 236,
        "productName": "Rare Replay Collection",
        "productType": "OFFER",
        "price": "60.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "60.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 134,
        "clientProductId": null,
        "baseProductName": "Recurring Replay Upsell",
        "productSku": null,
        "productDescription": "Rare Replay-Combination",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 30,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 49.79,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": [{
          "comboProductId": 136,
          "comboProductName": "Perfect Dark",
          "parentProductId": 134,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 133,
          "comboProductName": "Halo 5",
          "parentProductId": 134,
          "stockQuantity": "0",
          "variants": [{"title": "Base", "variantDetailId": "230", "stockQuantity": "0"}, {
            "title": "Platinum",
            "variantDetailId": "231",
            "stockQuantity": "0"
          }, {"title": "Collector", "variantDetailId": "232", "stockQuantity": "0"}]
        }, {
          "comboProductId": 132,
          "comboProductName": "Gears of War 5",
          "parentProductId": 134,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 135,
          "comboProductName": "Banjo Kazooie",
          "parentProductId": 134,
          "stockQuantity": "0",
          "variants": []
        }]
      }, {
        "campaignProductId": 242,
        "productName": "Xbox T-Shirt Multi Variant",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 137,
        "clientProductId": null,
        "baseProductName": "Xbox T-Shirt",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "Black / Xbox / small",
          "productSku": null,
          "price": "5.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 269,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Black",
          "variantOptionName2": "Xbox",
          "variantOptionName3": "small",
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": 1,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 2.5,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "Black / Xbox / medium",
          "productSku": null,
          "price": "6.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 270,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Black",
          "variantOptionName2": "Xbox",
          "variantOptionName3": "medium",
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": 2,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 3,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "Black / Xbox / large",
          "productSku": null,
          "price": "7.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 271,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Black",
          "variantOptionName2": "Xbox",
          "variantOptionName3": "large",
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": 3,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 3.5,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "Black / One / small",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 272,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Black",
          "variantOptionName2": "One",
          "variantOptionName3": "small",
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": 1,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Black / One / medium",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 273,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Black",
          "variantOptionName2": "One",
          "variantOptionName3": "medium",
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": 2,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Black / One / large",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 274,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Black",
          "variantOptionName2": "One",
          "variantOptionName3": "large",
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": 3,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Black / Series / small",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 275,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Black",
          "variantOptionName2": "Series",
          "variantOptionName3": "small",
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": 1,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Black / Series / medium",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 276,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Black",
          "variantOptionName2": "Series",
          "variantOptionName3": "medium",
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": 2,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Black / Series / large",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 277,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Black",
          "variantOptionName2": "Series",
          "variantOptionName3": "large",
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": 3,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "White / Xbox / small",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 278,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "White",
          "variantOptionName2": "Xbox",
          "variantOptionName3": "small",
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": 1,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "White / Xbox / medium",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 279,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "White",
          "variantOptionName2": "Xbox",
          "variantOptionName3": "medium",
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": 2,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "White / Xbox / large",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 280,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "White",
          "variantOptionName2": "Xbox",
          "variantOptionName3": "large",
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": 3,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "White / One / small",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 281,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "White",
          "variantOptionName2": "One",
          "variantOptionName3": "small",
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": 1,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "White / One / medium",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 282,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "White",
          "variantOptionName2": "One",
          "variantOptionName3": "medium",
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": 2,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "White / One / large",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 283,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "White",
          "variantOptionName2": "One",
          "variantOptionName3": "large",
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": 3,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "White / Series / small",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 284,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "White",
          "variantOptionName2": "Series",
          "variantOptionName3": "small",
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": 1,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "White / Series / medium",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 285,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "White",
          "variantOptionName2": "Series",
          "variantOptionName3": "medium",
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": 2,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "White / Series / large",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 286,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "White",
          "variantOptionName2": "Series",
          "variantOptionName3": "large",
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": 3,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Green / Xbox / small",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 287,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Green",
          "variantOptionName2": "Xbox",
          "variantOptionName3": "small",
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": 1,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Green / Xbox / medium",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 288,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Green",
          "variantOptionName2": "Xbox",
          "variantOptionName3": "medium",
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": 2,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Green / Xbox / large",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 289,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Green",
          "variantOptionName2": "Xbox",
          "variantOptionName3": "large",
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": 3,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Green / One / small",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 290,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Green",
          "variantOptionName2": "One",
          "variantOptionName3": "small",
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": 1,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Green / One / medium",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 291,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Green",
          "variantOptionName2": "One",
          "variantOptionName3": "medium",
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": 2,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Green / One / large",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 292,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Green",
          "variantOptionName2": "One",
          "variantOptionName3": "large",
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": 3,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Green / Series / small",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 293,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Green",
          "variantOptionName2": "Series",
          "variantOptionName3": "small",
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": 1,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Green / Series / medium",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 294,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Green",
          "variantOptionName2": "Series",
          "variantOptionName3": "medium",
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": 2,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Green / Series / large",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 295,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "Logo",
          "variantName3": "Size",
          "variantOptionName1": "Green",
          "variantOptionName2": "Series",
          "variantOptionName3": "large",
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": 3,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 243,
        "productName": "Combo Product w/ multi variant product",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 138,
        "clientProductId": null,
        "baseProductName": "MV Prod",
        "productSku": null,
        "productDescription": "Combo Product w/ multi variant prod",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": [{
          "comboProductId": 137,
          "comboProductName": "Xbox T-Shirt",
          "parentProductId": 138,
          "stockQuantity": "0",
          "variants": [{
            "title": "Black / Xbox / small",
            "variantDetailId": "269",
            "stockQuantity": "0"
          }, {
            "title": "Black / Xbox / medium",
            "variantDetailId": "270",
            "stockQuantity": "0"
          }, {
            "title": "Black / Xbox / large",
            "variantDetailId": "271",
            "stockQuantity": "0"
          }, {
            "title": "Black / One / small",
            "variantDetailId": "272",
            "stockQuantity": "0"
          }, {
            "title": "Black / One / medium",
            "variantDetailId": "273",
            "stockQuantity": "0"
          }, {
            "title": "Black / One / large",
            "variantDetailId": "274",
            "stockQuantity": "0"
          }, {
            "title": "Black / Series / small",
            "variantDetailId": "275",
            "stockQuantity": "0"
          }, {
            "title": "Black / Series / medium",
            "variantDetailId": "276",
            "stockQuantity": "0"
          }, {
            "title": "Black / Series / large",
            "variantDetailId": "277",
            "stockQuantity": "0"
          }, {
            "title": "White / Xbox / small",
            "variantDetailId": "278",
            "stockQuantity": "0"
          }, {
            "title": "White / Xbox / medium",
            "variantDetailId": "279",
            "stockQuantity": "0"
          }, {
            "title": "White / Xbox / large",
            "variantDetailId": "280",
            "stockQuantity": "0"
          }, {
            "title": "White / One / small",
            "variantDetailId": "281",
            "stockQuantity": "0"
          }, {
            "title": "White / One / medium",
            "variantDetailId": "282",
            "stockQuantity": "0"
          }, {
            "title": "White / One / large",
            "variantDetailId": "283",
            "stockQuantity": "0"
          }, {
            "title": "White / Series / small",
            "variantDetailId": "284",
            "stockQuantity": "0"
          }, {
            "title": "White / Series / medium",
            "variantDetailId": "285",
            "stockQuantity": "0"
          }, {
            "title": "White / Series / large",
            "variantDetailId": "286",
            "stockQuantity": "0"
          }, {
            "title": "Green / Xbox / small",
            "variantDetailId": "287",
            "stockQuantity": "0"
          }, {
            "title": "Green / Xbox / medium",
            "variantDetailId": "288",
            "stockQuantity": "0"
          }, {
            "title": "Green / Xbox / large",
            "variantDetailId": "289",
            "stockQuantity": "0"
          }, {
            "title": "Green / One / small",
            "variantDetailId": "290",
            "stockQuantity": "0"
          }, {
            "title": "Green / One / medium",
            "variantDetailId": "291",
            "stockQuantity": "0"
          }, {
            "title": "Green / One / large",
            "variantDetailId": "292",
            "stockQuantity": "0"
          }, {
            "title": "Green / Series / small",
            "variantDetailId": "293",
            "stockQuantity": "0"
          }, {
            "title": "Green / Series / medium",
            "variantDetailId": "294",
            "stockQuantity": "0"
          }, {"title": "Green / Series / large", "variantDetailId": "295", "stockQuantity": "0"}]
        }, {
          "comboProductId": 133,
          "comboProductName": "Halo 5",
          "parentProductId": 138,
          "stockQuantity": "0",
          "variants": [{"title": "Base", "variantDetailId": "230", "stockQuantity": "0"}, {
            "title": "Platinum",
            "variantDetailId": "231",
            "stockQuantity": "0"
          }, {"title": "Collector", "variantDetailId": "232", "stockQuantity": "0"}]
        }, {
          "comboProductId": 123,
          "comboProductName": "DayZ",
          "parentProductId": 138,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 138,
          "comboProductName": "MV Prod",
          "parentProductId": 138,
          "stockQuantity": "0",
          "variants": []
        }]
      }, {
        "campaignProductId": 244,
        "productName": "Rare Replay-Combination",
        "productType": "UPSALE",
        "price": "99.58",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "99.58",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 134,
        "clientProductId": null,
        "baseProductName": "Recurring Replay Upsell",
        "productSku": null,
        "productDescription": "Rare Replay-Combination",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 30,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 49.79,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": [{
          "comboProductId": 136,
          "comboProductName": "Perfect Dark",
          "parentProductId": 134,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 133,
          "comboProductName": "Halo 5",
          "parentProductId": 134,
          "stockQuantity": "0",
          "variants": [{"title": "Base", "variantDetailId": "230", "stockQuantity": "0"}, {
            "title": "Platinum",
            "variantDetailId": "231",
            "stockQuantity": "0"
          }, {"title": "Collector", "variantDetailId": "232", "stockQuantity": "0"}]
        }, {
          "comboProductId": 132,
          "comboProductName": "Gears of War 5",
          "parentProductId": 134,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 135,
          "comboProductName": "Banjo Kazooie",
          "parentProductId": 134,
          "stockQuantity": "0",
          "variants": []
        }]
      }, {
        "campaignProductId": 246,
        "productName": "MW2-Combination",
        "productType": "UPSALE",
        "price": "25.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "25.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 122,
        "clientProductId": null,
        "baseProductName": "MW2 Combo",
        "productSku": null,
        "productDescription": "MW2 Combo Offer",
        "productCost": "43.00",
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "game,shooter",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "Base",
          "productSku": null,
          "price": "60.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 228,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Option",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Base",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 30,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "Platnum",
          "productSku": null,
          "price": "80.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 229,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Option",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Platnum",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": null,
            "price": 40,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "15.00",
          "price": 12.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 12.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": [{
          "comboProductId": 127,
          "comboProductName": "Game Pass PC",
          "parentProductId": 122,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 132,
          "comboProductName": "Gears of War 5",
          "parentProductId": 122,
          "stockQuantity": "0",
          "variants": []
        }, {
          "comboProductId": 131,
          "comboProductName": "Fall Guys",
          "parentProductId": 122,
          "stockQuantity": "0",
          "variants": []
        }]
      }, {
        "campaignProductId": 268,
        "productName": "(120) Product w/ variants 5",
        "productType": "OFFER",
        "price": "30.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "30.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 120,
        "clientProductId": null,
        "baseProductName": "Product w/ variants 3",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "Price1",
          "productSku": null,
          "price": "3.33",
          "shippingPrice": "4.44",
          "compareAtPrice": null,
          "variantDetailId": 225,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "same price",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Price1",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": "4.44",
            "price": 1.67,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "Price2",
          "productSku": null,
          "price": "3.33",
          "shippingPrice": "4.44",
          "compareAtPrice": null,
          "variantDetailId": 226,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "same price",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Price2",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": "4.44",
            "price": 1.67,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "Price3",
          "productSku": null,
          "price": "3.33",
          "shippingPrice": "4.44",
          "compareAtPrice": null,
          "variantDetailId": 227,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "same price",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Price3",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": "",
          "memberPricing": [{
            "isFreeShipping": false,
            "isMemberShipping": false,
            "shipPrice": "4.44",
            "price": 1.67,
            "clubPluginId": 13,
            "clubProductId": 121
          }]
        }, {
          "title": "Price4",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 303,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "same price",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Price4",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 4,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Price5",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 304,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "same price",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Price5",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 5,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 15,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 365,
        "productName": "(189) 2var",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 189,
        "clientProductId": null,
        "baseProductName": "2var",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "white",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 398,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "white",
          "variantOptionName2": "s",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "blue",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 401,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "blue",
          "variantOptionName2": "s",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "green",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 404,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "green",
          "variantOptionName2": "s",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 366,
        "productName": "2var",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 189,
        "clientProductId": null,
        "baseProductName": "2var",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "white",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 398,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "white",
          "variantOptionName2": "s",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "blue",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 401,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "blue",
          "variantOptionName2": "s",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "green",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 404,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "green",
          "variantOptionName2": "s",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 367,
        "productName": "1var",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 190,
        "clientProductId": null,
        "baseProductName": "1var",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "small",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 407,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Size",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "small",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "medium",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 408,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Size",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "medium",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "large",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 409,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Size",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "large",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 385,
        "productName": "Game Pass PC single purchase test",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 127,
        "clientProductId": null,
        "baseProductName": "Game Pass PC",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 386,
        "productName": "Game Pass PC single purchase test decline",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 127,
        "clientProductId": null,
        "baseProductName": "Game Pass PC",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": 13,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [],
        "combinations": []
      }, {
        "campaignProductId": 388,
        "productName": "subandsave",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 198,
        "clientProductId": null,
        "baseProductName": "subandsave",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 399,
        "productName": "FARES TEST",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 24,
        "billerName": "Dummy",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 217,
        "clientProductId": null,
        "baseProductName": "FARES TEST",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 401,
        "productName": "ATRI-OFFER",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": null,
        "billerName": null,
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": 1,
        "loadBalancerName": "Main Test",
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 219,
        "clientProductId": null,
        "baseProductName": "ATRI-TEST",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 402,
        "productName": "ATRI 2",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": null,
        "billerName": null,
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": 3,
        "loadBalancerName": "Atri 3",
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 219,
        "clientProductId": null,
        "baseProductName": "ATRI-TEST",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 403,
        "productName": "ATRI 3",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 219,
        "clientProductId": null,
        "baseProductName": "ATRI-TEST",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 404,
        "productName": "ATRI 4",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": null,
        "billerName": null,
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": 2,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 219,
        "clientProductId": null,
        "baseProductName": "ATRI-TEST",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 405,
        "productName": "ATRI 4",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 219,
        "clientProductId": null,
        "baseProductName": "ATRI-TEST",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 406,
        "productName": "ATRI 4",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": null,
        "billerName": null,
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": 2,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 219,
        "clientProductId": null,
        "baseProductName": "ATRI-TEST",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 407,
        "productName": "ATRI 4",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": null,
        "billerName": null,
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": 2,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 219,
        "clientProductId": null,
        "baseProductName": "ATRI-TEST",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 411,
        "productName": "Game Pass 1 month",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 220,
        "clientProductId": "THEGAMEPASS",
        "baseProductName": "Game Pass Sub and Save example",
        "productSku": "THEBESTGAMEPASS",
        "productDescription": "Play Games from the Cloud — Discover Your Next Favorite Game, Plus EA Play + Same Day Releases. Join Now. Play Brand New Games Day 1 on Console, PC, and Mobile from Xbox Game Studios and More. Palworld. Join Xbox Game Pass. Grounded. Monster Hunter Rise. Hello Neighbor 2. Valheim.",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product220.png",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 439,
        "productName": "TacX Product Shipping",
        "productType": "OFFER",
        "price": "20.00",
        "shippingPrice": "5.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "20.00",
        "cycle1_shipPrice": "5.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 87,
        "clientProductId": null,
        "baseProductName": "TacX Product",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "10",
        "productCategoryName": "extremegadgetz.myshopify.com",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": "7267896328381",
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "0 / 0",
          "productSku": null,
          "price": "0.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 151,
          "externalVariantDetailId": "42018495332541",
          "isOutOfStock": 0,
          "weight": "0.000",
          "productQty": null,
          "billDelay": null,
          "variantName1": "0",
          "variantName2": "Metal Color",
          "variantName3": null,
          "variantOptionName1": "0",
          "variantOptionName2": "0",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "0 / 1",
          "productSku": null,
          "price": "0.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 152,
          "externalVariantDetailId": "42018495365309",
          "isOutOfStock": 0,
          "weight": "0.000",
          "productQty": null,
          "billDelay": null,
          "variantName1": "0",
          "variantName2": "Metal Color",
          "variantName3": null,
          "variantOptionName1": "0",
          "variantOptionName2": "1",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "0 / 2",
          "productSku": null,
          "price": "0.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 153,
          "externalVariantDetailId": "42018495430845",
          "isOutOfStock": 0,
          "weight": "0.000",
          "productQty": null,
          "billDelay": null,
          "variantName1": "0",
          "variantName2": "Metal Color",
          "variantName3": null,
          "variantOptionName1": "0",
          "variantOptionName2": "2",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "1 / 0",
          "productSku": null,
          "price": "0.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 154,
          "externalVariantDetailId": "42018495463613",
          "isOutOfStock": 0,
          "weight": "0.000",
          "productQty": null,
          "billDelay": null,
          "variantName1": "0",
          "variantName2": "Metal Color",
          "variantName3": null,
          "variantOptionName1": "1",
          "variantOptionName2": "0",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "1 / 1",
          "productSku": null,
          "price": "0.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 155,
          "externalVariantDetailId": "42018495496381",
          "isOutOfStock": 0,
          "weight": "0.000",
          "productQty": null,
          "billDelay": null,
          "variantName1": "0",
          "variantName2": "Metal Color",
          "variantName3": null,
          "variantOptionName1": "1",
          "variantOptionName2": "1",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "1 / 2",
          "productSku": null,
          "price": "0.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 156,
          "externalVariantDetailId": "42018495561917",
          "isOutOfStock": 0,
          "weight": "0.000",
          "productQty": null,
          "billDelay": null,
          "variantName1": "0",
          "variantName2": "Metal Color",
          "variantName3": null,
          "variantOptionName1": "1",
          "variantOptionName2": "2",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "2 / 0",
          "productSku": null,
          "price": "0.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 157,
          "externalVariantDetailId": "42018495594685",
          "isOutOfStock": 0,
          "weight": "0.000",
          "productQty": null,
          "billDelay": null,
          "variantName1": "0",
          "variantName2": "Metal Color",
          "variantName3": null,
          "variantOptionName1": "2",
          "variantOptionName2": "0",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "2 / 1",
          "productSku": null,
          "price": "0.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 158,
          "externalVariantDetailId": "42018495725757",
          "isOutOfStock": 0,
          "weight": "0.000",
          "productQty": null,
          "billDelay": null,
          "variantName1": "0",
          "variantName2": "Metal Color",
          "variantName3": null,
          "variantOptionName1": "2",
          "variantOptionName2": "1",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "2 / 2",
          "productSku": null,
          "price": "0.00",
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 159,
          "externalVariantDetailId": "42018495791293",
          "isOutOfStock": 0,
          "weight": "0.000",
          "productQty": null,
          "billDelay": null,
          "variantName1": "0",
          "variantName2": "Metal Color",
          "variantName3": null,
          "variantOptionName1": "2",
          "variantOptionName2": "2",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "5.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 440,
        "productName": "Controller",
        "productType": "OFFER",
        "price": "60.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "60.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 221,
        "clientProductId": null,
        "baseProductName": "Controller",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "red",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 411,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "red",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "yellow",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 412,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "yellow",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "green",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 413,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "green",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 30,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 442,
        "productName": "(224) this",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 224,
        "clientProductId": null,
        "baseProductName": "this",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "this",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 443,
        "productName": "Halo 5",
        "productType": "UPSALE",
        "price": "20.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "20.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 133,
        "clientProductId": null,
        "baseProductName": "Halo 5",
        "productSku": "d1f3sd1fa3s",
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": "3",
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "buy2",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "Base",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 230,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Base",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Platinum",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 231,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Platinum",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "Collector",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 232,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Tier",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "Collector",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 448,
        "productName": "Controller (FREE)",
        "productType": "OFFER",
        "price": "0.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "0.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 221,
        "clientProductId": null,
        "baseProductName": "Controller",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "red",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 411,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "red",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "yellow",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 412,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "yellow",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "green",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 413,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "green",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 30,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 451,
        "productName": "Max Order Offer",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 4,
        "billerName": "DECLINE dummy",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 123,
        "clientProductId": null,
        "baseProductName": "DayZ",
        "productSku": null,
        "productDescription": null,
        "productCost": "14.99",
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product123.png",
        "stockQuantity": "0",
        "allowStorePickup": 1,
        "productTags": "buy2",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "9.99",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 4.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 40,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 17.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 3,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "15.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 50,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 452,
        "productName": "upsell routing",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 5,
        "billerName": "Dummy",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 226,
        "clientProductId": null,
        "baseProductName": "upsell routing",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "yellow",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 427,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "yellow",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "red",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 428,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "red",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "white",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 429,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "white",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 455,
        "productName": "TIP",
        "productType": "OFFER",
        "price": "6.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "6.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 123,
        "clientProductId": null,
        "baseProductName": "DayZ",
        "productSku": null,
        "productDescription": null,
        "productCost": "14.99",
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product123.png",
        "stockQuantity": "0",
        "allowStorePickup": 1,
        "productTags": "buy2",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 1,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "9.99",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 4.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 40,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 17.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 3,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "15.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 50,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 456,
        "productName": "Tip",
        "productType": "UPSALE",
        "price": "10.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "10.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 123,
        "clientProductId": null,
        "baseProductName": "DayZ",
        "productSku": null,
        "productDescription": null,
        "productCost": "14.99",
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product123.png",
        "stockQuantity": "0",
        "allowStorePickup": 1,
        "productTags": "buy2",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 1,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "9.99",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 4.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 40,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 17.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 3,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "15.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 50,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 462,
        "productName": "RE5",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "15.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "15.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 123,
        "clientProductId": null,
        "baseProductName": "DayZ",
        "productSku": null,
        "productDescription": null,
        "productCost": "14.99",
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product123.png",
        "stockQuantity": "0",
        "allowStorePickup": 1,
        "productTags": "buy2",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "9.99",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 4.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 40,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 17.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 3,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "15.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 50,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 470,
        "productName": "sub and save (one time)",
        "productType": "OFFER",
        "price": "50.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "50.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 235,
        "clientProductId": null,
        "baseProductName": "sub and save",
        "productSku": null,
        "productDescription": null,
        "productCost": null,
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 0,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 20,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 25,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 472,
        "productName": "(236) testaaa",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 236,
        "clientProductId": null,
        "baseProductName": "testaaa",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 476,
        "productName": "DayZ",
        "productType": "OFFER",
        "price": "99.99",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "99.99",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 123,
        "clientProductId": null,
        "baseProductName": "DayZ",
        "productSku": null,
        "productDescription": null,
        "productCost": "14.99",
        "shippingCost": null,
        "weight": "5.000",
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product123.png",
        "stockQuantity": "0",
        "allowStorePickup": 1,
        "productTags": "buy2",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "9.99",
          "price": 0,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 4.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 40,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 17.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 3,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "15.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 50,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 477,
        "productName": "Blue T-Shirt",
        "productType": "OFFER",
        "price": "30.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "30.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 240,
        "clientProductId": null,
        "baseProductName": "Blue T-Shirt",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 15,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 479,
        "productName": "Classic White Polo",
        "productType": "OFFER",
        "price": "19.99",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "19.99",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 241,
        "clientProductId": null,
        "baseProductName": "Classic White Polo",
        "productSku": null,
        "productDescription": "Wonderful white polo made of a cotton polyester blend",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "23",
        "productCategoryName": "Store Funnel",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product241.jpeg",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "polo,shirt",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "sm",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 463,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Size",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "sm",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "med",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 464,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Size",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "med",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "lg",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 465,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Size",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "lg",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 8,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 480,
        "productName": "Classic Polo",
        "productType": "OFFER",
        "price": "24.99",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "24.99",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 242,
        "clientProductId": null,
        "baseProductName": "Classic Polo",
        "productSku": null,
        "productDescription": "Wonderful color polo made of a cotton polyester blend",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "23",
        "productCategoryName": "Store Funnel",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product242.jpeg",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "polo,shirt",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "grey / sm",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 439,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "grey",
          "variantOptionName2": "sm",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "grey / med",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 440,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "grey",
          "variantOptionName2": "med",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "grey / lg",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 441,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "grey",
          "variantOptionName2": "lg",
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "blue / sm",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 442,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "blue",
          "variantOptionName2": "sm",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "blue / med",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 443,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "blue",
          "variantOptionName2": "med",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "blue / lg",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 444,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "blue",
          "variantOptionName2": "lg",
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "burgundy / sm",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 445,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "burgundy",
          "variantOptionName2": "sm",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "burgundy / med",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 446,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "burgundy",
          "variantOptionName2": "med",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "burgundy / lg",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 447,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "burgundy",
          "variantOptionName2": "lg",
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "egg shell / sm",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 448,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "egg shell",
          "variantOptionName2": "sm",
          "variantOptionName3": null,
          "variantOptionSequence1": 4,
          "variantOptionSequence2": 1,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "egg shell / med",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 449,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "egg shell",
          "variantOptionName2": "med",
          "variantOptionName3": null,
          "variantOptionSequence1": 4,
          "variantOptionSequence2": 2,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "egg shell / lg",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 450,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": "size",
          "variantName3": null,
          "variantOptionName1": "egg shell",
          "variantOptionName2": "lg",
          "variantOptionName3": null,
          "variantOptionSequence1": 4,
          "variantOptionSequence2": 3,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 12,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 12.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 481,
        "productName": "Graphic T-Shirt",
        "productType": "OFFER",
        "price": "22.99",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "22.99",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 244,
        "clientProductId": null,
        "baseProductName": "Graphic T-Shirt",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "23",
        "productCategoryName": "Store Funnel",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product244.jpeg",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "tee,shirt",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 9.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 11.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 485,
        "productName": "Classic White Polo 2",
        "productType": "OFFER",
        "price": "20.00",
        "shippingPrice": "0.00",
        "compareAtPrice": "0.00",
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "20.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 0,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 241,
        "clientProductId": null,
        "baseProductName": "Classic White Polo",
        "productSku": null,
        "productDescription": "Wonderful white polo made of a cotton polyester blend",
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "23",
        "productCategoryName": "Store Funnel",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "https://vaimages.konnektive.com/chriscompany/product241.jpeg",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": "polo,shirt",
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "sm",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 463,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Size",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "sm",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "med",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 464,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Size",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "med",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "lg",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 465,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Size",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "lg",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 8,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 10,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 486,
        "productName": "Upsell",
        "productType": "UPSALE",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 0,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 226,
        "clientProductId": null,
        "baseProductName": "upsell routing",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "4",
        "productCategoryName": "miscellaneous",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": true,
        "variants": [{
          "title": "yellow",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 427,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "yellow",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 1,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "red",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 428,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "red",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 2,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }, {
          "title": "white",
          "productSku": null,
          "price": null,
          "shippingPrice": null,
          "compareAtPrice": null,
          "variantDetailId": 429,
          "externalVariantDetailId": null,
          "isOutOfStock": 0,
          "weight": null,
          "productQty": null,
          "billDelay": null,
          "variantName1": "Color",
          "variantName2": null,
          "variantName3": null,
          "variantOptionName1": "white",
          "variantOptionName2": null,
          "variantOptionName3": null,
          "variantOptionSequence1": 3,
          "variantOptionSequence2": null,
          "variantOptionSequence3": null,
          "stockQuantity": 0,
          "imageUrl": ""
        }],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }, {
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }, {
        "campaignProductId": 488,
        "productName": "Bundle",
        "productType": "OFFER",
        "price": "15.00",
        "shippingPrice": "0.00",
        "compareAtPrice": null,
        "billerId": 14,
        "billerName": "Approvals",
        "showToAffiliates": 1,
        "useOfferMid": 0,
        "loadBalancerId": null,
        "loadBalancerName": null,
        "billingCycleType": "ONE_TIME",
        "finalBillingCycle": null,
        "staggerFulfillments": 0,
        "staggerIntervalCycles": null,
        "cycle1_price": "15.00",
        "cycle1_shipPrice": "0.00",
        "cycle1_isShippable": 1,
        "cycle1_billDelay": null,
        "cycle2_price": null,
        "cycle2_shipPrice": null,
        "cycle2_isShippable": 0,
        "cycle2_billDelay": null,
        "cycle3_price": null,
        "cycle3_shipPrice": null,
        "cycle3_isShippable": 0,
        "cycle3_billDelay": null,
        "trialEnabled": 0,
        "trialType": null,
        "trialAuthType": null,
        "trialBillerId": null,
        "trialBillerName": null,
        "trialLoadBalancerId": null,
        "trialLoadBalancerName": null,
        "minOrderPrice": "0.00",
        "maxOrderPrice": null,
        "maxOrderQty": null,
        "productId": 245,
        "clientProductId": null,
        "baseProductName": "Bundle",
        "productSku": null,
        "productDescription": null,
        "productCost": "0.00",
        "shippingCost": null,
        "weight": null,
        "msrp": null,
        "isVariantBundle": 0,
        "bundleProductQty": null,
        "productQty": 1,
        "campaignProductQty": null,
        "productCategoryId": "7",
        "productCategoryName": "Video Games",
        "isProductCombo": null,
        "fulfillmentCycleType": "RECURRING",
        "fulfillmentHouseId": null,
        "fulfillmentDelayHours": 1,
        "clubPluginId": null,
        "externalProductId": null,
        "imageUrl": "",
        "stockQuantity": "0",
        "allowStorePickup": 0,
        "productTags": null,
        "variantDetailId": null,
        "externalVariantDetailId": null,
        "isEditable": 0,
        "storefront": 1,
        "taxServiceId": null,
        "descriptor": null,
        "fixedBillingDay": null,
        "persistentRebillDay": 0,
        "isPricePercent": 0,
        "hasVariants": false,
        "variants": [],
        "memberPricing": [{
          "isFreeShipping": false,
          "isMemberShipping": false,
          "shipPrice": "0.00",
          "price": 7.5,
          "clubPluginId": 13,
          "clubProductId": 121
        }],
        "combinations": []
      }],
      "countries": [{
        "countryName": "United States",
        "countryCode": "US",
        "continent": "NA",
        "currencyCode": "USD",
        "numericCode": "840"
      }, {
        "countryName": "Albania",
        "countryCode": "AL",
        "continent": "EU",
        "currencyCode": "ALL",
        "numericCode": "008"
      }, {
        "countryName": "Cyprus",
        "countryCode": "CY",
        "continent": "EU",
        "currencyCode": "EUR",
        "numericCode": "196"
      }, {
        "countryName": "Andorra",
        "countryCode": "AD",
        "continent": "EU",
        "currencyCode": "EUR",
        "numericCode": "020"
      }, {
        "countryName": "United Arab Emirates",
        "countryCode": "AE",
        "continent": "AS",
        "currencyCode": "AED",
        "numericCode": "784"
      }, {
        "countryName": "Saudi Arabia",
        "countryCode": "SA",
        "continent": "AS",
        "currencyCode": "SAR",
        "numericCode": "682"
      }, {
        "countryName": "Serbia",
        "countryCode": "RS",
        "continent": "NA",
        "currencyCode": null,
        "numericCode": null
      }, {
        "countryName": "Egypt",
        "countryCode": "EG",
        "continent": "AF",
        "currencyCode": "EGP",
        "numericCode": "818"
      }, {
        "countryName": "Slovak Republic",
        "countryCode": "SK",
        "continent": "EU",
        "currencyCode": "EUR",
        "numericCode": "703"
      }, {
        "countryName": "Slovenia",
        "countryCode": "SI",
        "continent": "EU",
        "currencyCode": "EUR",
        "numericCode": "705"
      }, {
        "countryName": "United Kingdom",
        "countryCode": "GB",
        "continent": "EU",
        "currencyCode": "GBP",
        "numericCode": "826"
      }, {
        "countryName": "Canada",
        "countryCode": "CA",
        "continent": "NA",
        "currencyCode": "CAD",
        "numericCode": "124"
      }, {
        "countryName": "India",
        "countryCode": "IN",
        "continent": "AS",
        "currencyCode": "INR",
        "numericCode": "356"
      }, {
        "countryName": "Australia",
        "countryCode": "AU",
        "continent": "AU",
        "currencyCode": "AUD",
        "numericCode": "036"
      }],
      "currencies": [{
        "currencyCode": "USD",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 1,
        "currencySymbol": "$",
        "currencyNumber": "840",
        "currencyName": "US Dollar"
      }, {
        "currencyCode": "EUR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "€",
        "currencyNumber": "978",
        "currencyName": "Euro"
      }, {
        "currencyCode": "ARS",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "AR$",
        "currencyNumber": "032",
        "currencyName": "Argentine Peso"
      }, {
        "currencyCode": "AED",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 1,
        "currencyFee": "0.00",
        "sendToGateway": 1,
        "currencySymbol": "AED",
        "currencyNumber": "784",
        "currencyName": "United Arab Emirates Dirham"
      }, {
        "currencyCode": "PHP",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 0,
        "rounding": 50,
        "currencyFee": "5.50",
        "sendToGateway": 1,
        "currencySymbol": "₱",
        "currencyNumber": "608",
        "currencyName": "Philippine Peso"
      }, {
        "currencyCode": "CAD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "CA$",
        "currencyNumber": "124",
        "currencyName": "Canadian Dollar"
      }, {
        "currencyCode": "MXN",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "MX$",
        "currencyNumber": "484",
        "currencyName": "Mexican Peso"
      }, {
        "currencyCode": "AFN",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Af",
        "currencyNumber": null,
        "currencyName": "Afghan Afghani"
      }, {
        "currencyCode": "ALL",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "ALL",
        "currencyNumber": "008",
        "currencyName": "Albanian Lek"
      }, {
        "currencyCode": "AMD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "AMD",
        "currencyNumber": "051",
        "currencyName": "Armenian Dram"
      }, {
        "currencyCode": "AUD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "AU$",
        "currencyNumber": "036",
        "currencyName": "Australian Dollar"
      }, {
        "currencyCode": "AZN",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "man.",
        "currencyNumber": "944",
        "currencyName": "Azerbaijani Manat"
      }, {
        "currencyCode": "BAM",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "KM",
        "currencyNumber": "977",
        "currencyName": "Bosnia-Herzegovina Convertible Mark"
      }, {
        "currencyCode": "BDT",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Tk",
        "currencyNumber": "050",
        "currencyName": "Bangladeshi Taka"
      }, {
        "currencyCode": "BGN",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "BGN",
        "currencyNumber": "975",
        "currencyName": "Bulgarian Lev"
      }, {
        "currencyCode": "BHD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "BD",
        "currencyNumber": "048",
        "currencyName": "Bahraini Dinar"
      }, {
        "currencyCode": "BIF",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "FBu",
        "currencyNumber": "108",
        "currencyName": "Burundian Franc"
      }, {
        "currencyCode": "BND",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "BN$",
        "currencyNumber": "096",
        "currencyName": "Brunei Dollar"
      }, {
        "currencyCode": "BOB",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Bs",
        "currencyNumber": "068",
        "currencyName": "Bolivian Boliviano"
      }, {
        "currencyCode": "BRL",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "R$",
        "currencyNumber": "986",
        "currencyName": "Brazilian Real"
      }, {
        "currencyCode": "BWP",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "BWP",
        "currencyNumber": "072",
        "currencyName": "Botswanan Pula"
      }, {
        "currencyCode": "BYR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "BYR",
        "currencyNumber": "974",
        "currencyName": "Belarusian Ruble"
      }, {
        "currencyCode": "BZD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "BZ$",
        "currencyNumber": "084",
        "currencyName": "Belize Dollar"
      }, {
        "currencyCode": "CDF",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "CDF",
        "currencyNumber": "976",
        "currencyName": "Congolese Franc"
      }, {
        "currencyCode": "CHF",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "CHF",
        "currencyNumber": "756",
        "currencyName": "Swiss Franc"
      }, {
        "currencyCode": "CLP",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "CL$",
        "currencyNumber": "152",
        "currencyName": "Chilean Peso"
      }, {
        "currencyCode": "CNY",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "CN¥",
        "currencyNumber": "156",
        "currencyName": "Chinese Yuan"
      }, {
        "currencyCode": "COP",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "CO$",
        "currencyNumber": "170",
        "currencyName": "Colombian Peso"
      }, {
        "currencyCode": "CRC",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "₡",
        "currencyNumber": "188",
        "currencyName": "Costa Rican Colón"
      }, {
        "currencyCode": "CVE",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "CV$",
        "currencyNumber": "132",
        "currencyName": "Cape Verdean Escudo"
      }, {
        "currencyCode": "CZK",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Kč",
        "currencyNumber": "203",
        "currencyName": "Czech Republic Koruna"
      }, {
        "currencyCode": "DJF",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Fdj",
        "currencyNumber": "262",
        "currencyName": "Djiboutian Franc"
      }, {
        "currencyCode": "DKK",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Dkr",
        "currencyNumber": "208",
        "currencyName": "Danish Krone"
      }, {
        "currencyCode": "DOP",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "RD$",
        "currencyNumber": "214",
        "currencyName": "Dominican Peso"
      }, {
        "currencyCode": "DZD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "DA",
        "currencyNumber": "012",
        "currencyName": "Algerian Dinar"
      }, {
        "currencyCode": "EEK",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Ekr",
        "currencyNumber": null,
        "currencyName": "Estonian Kroon"
      }, {
        "currencyCode": "EGP",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "EGP",
        "currencyNumber": "818",
        "currencyName": "Egyptian Pound"
      }, {
        "currencyCode": "ERN",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Nfk",
        "currencyNumber": "232",
        "currencyName": "Eritrean Nakfa"
      }, {
        "currencyCode": "ETB",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Br",
        "currencyNumber": "230",
        "currencyName": "Ethiopian Birr"
      }, {
        "currencyCode": "GBP",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "£",
        "currencyNumber": "826",
        "currencyName": "British Pound Sterling"
      }, {
        "currencyCode": "GEL",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "GEL",
        "currencyNumber": "981",
        "currencyName": "Georgian Lari"
      }, {
        "currencyCode": "GHS",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "GH₵",
        "currencyNumber": "936",
        "currencyName": "Ghanaian Cedi"
      }, {
        "currencyCode": "GNF",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "FG",
        "currencyNumber": "324",
        "currencyName": "Guinean Franc"
      }, {
        "currencyCode": "GTQ",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "GTQ",
        "currencyNumber": "320",
        "currencyName": "Guatemalan Quetzal"
      }, {
        "currencyCode": "HKD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "HK$",
        "currencyNumber": "344",
        "currencyName": "Hong Kong Dollar"
      }, {
        "currencyCode": "HNL",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "HNL",
        "currencyNumber": "340",
        "currencyName": "Honduran Lempira"
      }, {
        "currencyCode": "HRK",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "kn",
        "currencyNumber": "191",
        "currencyName": "Croatian Kuna"
      }, {
        "currencyCode": "HUF",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Ft",
        "currencyNumber": "348",
        "currencyName": "Hungarian Forint"
      }, {
        "currencyCode": "IDR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Rp",
        "currencyNumber": "360",
        "currencyName": "Indonesian Rupiah"
      }, {
        "currencyCode": "ILS",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "₪",
        "currencyNumber": "376",
        "currencyName": "Israeli New Sheqel"
      }, {
        "currencyCode": "INR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Rs",
        "currencyNumber": "356",
        "currencyName": "Indian Rupee"
      }, {
        "currencyCode": "IQD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "IQD",
        "currencyNumber": "368",
        "currencyName": "Iraqi Dinar"
      }, {
        "currencyCode": "IRR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "IRR",
        "currencyNumber": "364",
        "currencyName": "Iranian Rial"
      }, {
        "currencyCode": "ISK",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Ikr",
        "currencyNumber": "352",
        "currencyName": "Icelandic Króna"
      }, {
        "currencyCode": "JMD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "J$",
        "currencyNumber": "388",
        "currencyName": "Jamaican Dollar"
      }, {
        "currencyCode": "JOD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "JD",
        "currencyNumber": "400",
        "currencyName": "Jordanian Dinar"
      }, {
        "currencyCode": "JPY",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "¥",
        "currencyNumber": "392",
        "currencyName": "Japanese Yen"
      }, {
        "currencyCode": "KES",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Ksh",
        "currencyNumber": "404",
        "currencyName": "Kenyan Shilling"
      }, {
        "currencyCode": "KHR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "KHR",
        "currencyNumber": "116",
        "currencyName": "Cambodian Riel"
      }, {
        "currencyCode": "KMF",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "CF",
        "currencyNumber": "174",
        "currencyName": "Comorian Franc"
      }, {
        "currencyCode": "KRW",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "₩",
        "currencyNumber": "410",
        "currencyName": "South Korean Won"
      }, {
        "currencyCode": "KWD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "KD",
        "currencyNumber": "414",
        "currencyName": "Kuwaiti Dinar"
      }, {
        "currencyCode": "KZT",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "KZT",
        "currencyNumber": "398",
        "currencyName": "Kazakhstani Tenge"
      }, {
        "currencyCode": "LBP",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "LB£",
        "currencyNumber": "422",
        "currencyName": "Lebanese Pound"
      }, {
        "currencyCode": "LKR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "SLRs",
        "currencyNumber": "144",
        "currencyName": "Sri Lankan Rupee"
      }, {
        "currencyCode": "LTL",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Lt",
        "currencyNumber": null,
        "currencyName": "Lithuanian Litas"
      }, {
        "currencyCode": "LVL",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Ls",
        "currencyNumber": null,
        "currencyName": "Latvian Lats"
      }, {
        "currencyCode": "LYD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "LD",
        "currencyNumber": "434",
        "currencyName": "Libyan Dinar"
      }, {
        "currencyCode": "MAD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "MAD",
        "currencyNumber": "504",
        "currencyName": "Moroccan Dirham"
      }, {
        "currencyCode": "MDL",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "MDL",
        "currencyNumber": "498",
        "currencyName": "Moldovan Leu"
      }, {
        "currencyCode": "MGA",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "MGA",
        "currencyNumber": "969",
        "currencyName": "Malagasy Ariary"
      }, {
        "currencyCode": "MKD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "MKD",
        "currencyNumber": "807",
        "currencyName": "Macedonian Denar"
      }, {
        "currencyCode": "MMK",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "MMK",
        "currencyNumber": "104",
        "currencyName": "Myanma Kyat"
      }, {
        "currencyCode": "MOP",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "MOP$",
        "currencyNumber": "446",
        "currencyName": "Macanese Pataca"
      }, {
        "currencyCode": "MUR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "MURs",
        "currencyNumber": "480",
        "currencyName": "Mauritian Rupee"
      }, {
        "currencyCode": "MYR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "RM",
        "currencyNumber": "458",
        "currencyName": "Malaysian Ringgit"
      }, {
        "currencyCode": "MZN",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "MTn",
        "currencyNumber": "943",
        "currencyName": "Mozambican Metical"
      }, {
        "currencyCode": "NAD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "N$",
        "currencyNumber": "516",
        "currencyName": "Namibian Dollar"
      }, {
        "currencyCode": "NGN",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "₦",
        "currencyNumber": "566",
        "currencyName": "Nigerian Naira"
      }, {
        "currencyCode": "NIO",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "C$",
        "currencyNumber": "558",
        "currencyName": "Nicaraguan Córdoba"
      }, {
        "currencyCode": "NOK",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Nkr",
        "currencyNumber": "578",
        "currencyName": "Norwegian Krone"
      }, {
        "currencyCode": "NPR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "NPRs",
        "currencyNumber": "524",
        "currencyName": "Nepalese Rupee"
      }, {
        "currencyCode": "NZD",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "NZ$",
        "currencyNumber": "554",
        "currencyName": "New Zealand Dollar"
      }, {
        "currencyCode": "OMR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "OMR",
        "currencyNumber": "512",
        "currencyName": "Omani Rial"
      }, {
        "currencyCode": "PAB",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "B/.",
        "currencyNumber": "590",
        "currencyName": "Panamanian Balboa"
      }, {
        "currencyCode": "PEN",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "S/.",
        "currencyNumber": "604",
        "currencyName": "Peruvian Nuevo Sol"
      }, {
        "currencyCode": "PKR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "PKRs",
        "currencyNumber": "586",
        "currencyName": "Pakistani Rupee"
      }, {
        "currencyCode": "PLN",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "zł",
        "currencyNumber": "985",
        "currencyName": "Polish Zloty"
      }, {
        "currencyCode": "PYG",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "₲",
        "currencyNumber": "600",
        "currencyName": "Paraguayan Guarani"
      }, {
        "currencyCode": "QAR",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "QR",
        "currencyNumber": "634",
        "currencyName": "Qatari Rial"
      }, {
        "currencyCode": "RON",
        "symbolAlign": "LEFT",
        "includeShipping": 1,
        "isComma": 0,
        "decimals": 2,
        "rounding": 0,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "RON",
        "currencyNumber": "946",
        "currencyName": "Romanian Leu"
      }, {
        "currencyCode": "XOF",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "CFA",
        "currencyNumber": "952",
        "currencyName": "CFA Franc BCEAO"
      }, {
        "currencyCode": "XAF",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "FCFA",
        "currencyNumber": "950",
        "currencyName": "CFA Franc BEAC"
      }, {
        "currencyCode": "TWD",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "NT$",
        "currencyNumber": "901",
        "currencyName": "New Taiwan Dollar"
      }, {
        "currencyCode": "RUB",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "RUB",
        "currencyNumber": "643",
        "currencyName": "Russian Ruble"
      }, {
        "currencyCode": "RWF",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "RWF",
        "currencyNumber": "646",
        "currencyName": "Rwandan Franc"
      }, {
        "currencyCode": "SAR",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "SR",
        "currencyNumber": "682",
        "currencyName": "Saudi Riyal"
      }, {
        "currencyCode": "RSD",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "din.",
        "currencyNumber": "941",
        "currencyName": "Serbian Dinar"
      }, {
        "currencyCode": "SGD",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "S$",
        "currencyNumber": "702",
        "currencyName": "Singapore Dollar"
      }, {
        "currencyCode": "SOS",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Ssh",
        "currencyNumber": "706",
        "currencyName": "Somali Shilling"
      }, {
        "currencyCode": "ZAR",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "R",
        "currencyNumber": "710",
        "currencyName": "South African Rand"
      }, {
        "currencyCode": "SDG",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "SDG",
        "currencyNumber": "938",
        "currencyName": "Sudanese Pound"
      }, {
        "currencyCode": "SEK",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Skr",
        "currencyNumber": "752",
        "currencyName": "Swedish Krona"
      }, {
        "currencyCode": "SYP",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "SY£",
        "currencyNumber": "760",
        "currencyName": "Syrian Pound"
      }, {
        "currencyCode": "TZS",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "TSh",
        "currencyNumber": "834",
        "currencyName": "Tanzanian Shilling"
      }, {
        "currencyCode": "THB",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "฿",
        "currencyNumber": "764",
        "currencyName": "Thai Baht"
      }, {
        "currencyCode": "TOP",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "T$",
        "currencyNumber": "776",
        "currencyName": "Tongan Paʻanga"
      }, {
        "currencyCode": "TTD",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "TT$",
        "currencyNumber": "780",
        "currencyName": "Trinidad and Tobago Dollar"
      }, {
        "currencyCode": "TND",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "DT",
        "currencyNumber": "788",
        "currencyName": "Tunisian Dinar"
      }, {
        "currencyCode": "TRY",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "TL",
        "currencyNumber": "949",
        "currencyName": "Turkish Lira"
      }, {
        "currencyCode": "UGX",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "USh",
        "currencyNumber": "800",
        "currencyName": "Ugandan Shilling"
      }, {
        "currencyCode": "UAH",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "₴",
        "currencyNumber": "980",
        "currencyName": "Ukrainian Hryvnia"
      }, {
        "currencyCode": "UYU",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "$U",
        "currencyNumber": "858",
        "currencyName": "Uruguayan Peso"
      }, {
        "currencyCode": "UZS",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "UZS",
        "currencyNumber": "860",
        "currencyName": "Uzbekistan Som"
      }, {
        "currencyCode": "VEF",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "Bs.F.",
        "currencyNumber": "937",
        "currencyName": "Venezuelan Bolívar"
      }, {
        "currencyCode": "VND",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "₫",
        "currencyNumber": "704",
        "currencyName": "Vietnamese Dong"
      }, {
        "currencyCode": "YER",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "YR",
        "currencyNumber": "886",
        "currencyName": "Yemeni Rial"
      }, {
        "currencyCode": "ZMK",
        "symbolAlign": "LEFT",
        "includeShipping": 0,
        "isComma": 0,
        "decimals": 2,
        "rounding": null,
        "currencyFee": "0.00",
        "sendToGateway": 0,
        "currencySymbol": "ZK",
        "currencyNumber": "967",
        "currencyName": "Zambian Kwacha"
      }],
      "taxes": [{
        "countryCode": "US",
        "countryName": "United States",
        "stateCode": "*",
        "stateName": null,
        "taxRate": "0.040000",
        "isVat": 0,
        "excludeRebills": 0,
        "applyToShipping": 1,
        "productTags": null,
        "postalCode": null
      }, {
        "countryCode": "CA",
        "countryName": "Canada",
        "stateCode": "*",
        "stateName": null,
        "taxRate": "0.150000",
        "isVat": 1,
        "excludeRebills": 0,
        "applyToShipping": 0,
        "productTags": null,
        "postalCode": null
      }],
      "coupons": [],
      "shipProfiles": [{
        "shipProfileId": 103,
        "profileName": "multi qty",
        "shipCarrier": "UPS",
        "shipMethod": null,
        "shipRefCode": null,
        "highestShipPriceOnly": 0,
        "isUpcharge": 0,
        "applyEntireOrder": 0,
        "freeShipThreshold": null,
        "skipUpsell": 0,
        "includeCoupons": 0,
        "rules": [{
          "region": "REG_NA",
          "state": "",
          "productTypeSelect": "SINGLE",
          "productCategoryId": "",
          "campaignProductId": "223",
          "productTags": "",
          "valueThreshold": "0.00",
          "weightThreshold": "0.000",
          "maxWeightThreshold": "0.000",
          "itemCountThreshold": "2",
          "ruleCarrier": "",
          "ruleMethod": "",
          "zoneId": "",
          "shipPrice": "10.00",
          "shipCost": "0.00"
        }, {
          "region": "",
          "state": "",
          "productTypeSelect": "SINGLE",
          "productCategoryId": "",
          "campaignProductId": "227",
          "productTags": "",
          "valueThreshold": "0.00",
          "weightThreshold": "0.000",
          "maxWeightThreshold": "0.000",
          "itemCountThreshold": "2",
          "ruleCarrier": "null",
          "ruleMethod": "",
          "zoneId": "",
          "shipPrice": "20.00",
          "shipCost": "0.00"
        }, {
          "region": "",
          "state": "",
          "productTypeSelect": "UPSELLS",
          "productCategoryId": "",
          "campaignProductId": "",
          "productTags": "",
          "valueThreshold": "0.00",
          "weightThreshold": "0.000",
          "maxWeightThreshold": "0.000",
          "itemCountThreshold": "2",
          "ruleCarrier": "",
          "ruleMethod": "",
          "zoneId": "",
          "shipPrice": "8.00",
          "shipCost": "8.00"
        }]
      }, {
        "shipProfileId": 105,
        "profileName": "one qty",
        "shipCarrier": null,
        "shipMethod": null,
        "shipRefCode": null,
        "highestShipPriceOnly": 0,
        "isUpcharge": 0,
        "applyEntireOrder": 0,
        "freeShipThreshold": null,
        "skipUpsell": 0,
        "includeCoupons": 0,
        "rules": [{
          "region": "",
          "state": "",
          "productTypeSelect": "PRODUCTS",
          "productCategoryId": "",
          "campaignProductId": "",
          "productTags": "",
          "valueThreshold": "0.00",
          "weightThreshold": "0.000",
          "maxWeightThreshold": "0.000",
          "itemCountThreshold": "5",
          "ruleCarrier": "",
          "ruleMethod": "",
          "zoneId": "",
          "shipPrice": "50.00",
          "shipCost": "0.00"
        }]
      }, {
        "shipProfileId": 108,
        "profileName": "Entire order test",
        "shipCarrier": null,
        "shipMethod": null,
        "shipRefCode": null,
        "highestShipPriceOnly": 0,
        "isUpcharge": 0,
        "applyEntireOrder": 1,
        "freeShipThreshold": null,
        "skipUpsell": 0,
        "includeCoupons": 0,
        "rules": null
      }, {
        "shipProfileId": 109,
        "profileName": "Default",
        "shipCarrier": null,
        "shipMethod": null,
        "shipRefCode": null,
        "highestShipPriceOnly": 0,
        "isUpcharge": 0,
        "applyEntireOrder": 1,
        "freeShipThreshold": null,
        "skipUpsell": 0,
        "includeCoupons": 0,
        "rules": [{
          "region": "",
          "state": "",
          "productTypeSelect": "ENTIREORDER",
          "productCategoryId": "",
          "campaignProductId": "",
          "productTags": "",
          "valueThreshold": "0.00",
          "weightThreshold": "0.000",
          "maxWeightThreshold": "0.000",
          "itemCountThreshold": "",
          "ruleCarrier": "",
          "ruleMethod": "",
          "zoneId": "",
          "shipPrice": "5.00",
          "shipCost": "0.00"
        }]
      }, {
        "shipProfileId": 110,
        "profileName": "upcharge",
        "shipCarrier": null,
        "shipMethod": null,
        "shipRefCode": null,
        "highestShipPriceOnly": 0,
        "isUpcharge": 1,
        "applyEntireOrder": 0,
        "freeShipThreshold": null,
        "skipUpsell": 0,
        "includeCoupons": 0,
        "rules": [{
          "region": "",
          "state": "",
          "productTypeSelect": "PRODUCTS",
          "productCategoryId": "",
          "campaignProductId": "",
          "productTags": "",
          "valueThreshold": "0.00",
          "weightThreshold": "0.000",
          "maxWeightThreshold": "0.000",
          "itemCountThreshold": "",
          "ruleCarrier": "",
          "ruleMethod": "",
          "zoneId": "",
          "shipPrice": "9.00",
          "shipCost": "0.00"
        }]
      }, {
        "shipProfileId": 111,
        "profileName": "Free ship threshold",
        "shipCarrier": null,
        "shipMethod": null,
        "shipRefCode": null,
        "highestShipPriceOnly": 0,
        "isUpcharge": 0,
        "applyEntireOrder": 0,
        "freeShipThreshold": "99.99",
        "skipUpsell": 0,
        "includeCoupons": 0,
        "rules": [{
          "region": "",
          "state": "",
          "productTypeSelect": "PRODUCTS",
          "productCategoryId": "",
          "campaignProductId": "",
          "productTags": "",
          "valueThreshold": "0.00",
          "weightThreshold": "0.000",
          "maxWeightThreshold": "0.000",
          "itemCountThreshold": "",
          "ruleCarrier": "",
          "ruleMethod": "",
          "zoneId": "",
          "shipPrice": "90.00",
          "shipCost": "0.00"
        }]
      }],
      "zones": [],
      "storePickup": [],
      "blacklist": null
    }
  };
  static options: {
    variants: [
      {
        "variantName1": "Color",
        "variantName2": "size",
        "variantName3": null,
        "variantOptionName1": "burgundy",
        "variantOptionName2": "sm",
        "variantOptionName3": null,
      },
      {
        "variantName1": "Color",
        "variantName2": "size",
        "variantName3": null,
        "variantOptionName1": "burgundy",
        "variantOptionName2": "md",
        "variantOptionName3": null,
      },
      {
        "variantName1": "Color",
        "variantName2": "size",
        "variantName3": null,
        "variantOptionName1": "burgundy",
        "variantOptionName2": "lg",
        "variantOptionName3": null,
      },
      {
        "variantName1": "Color",
        "variantName2": "size",
        "variantName3": null,
        "variantOptionName1": "grey",
        "variantOptionName2": "sm",
        "variantOptionName3": null,
      },
      {
        "variantName1": "Color",
        "variantName2": "size",
        "variantName3": null,
        "variantOptionName1": "grey",
        "variantOptionName2": "md",
        "variantOptionName3": null,
      },
      {
        "variantName1": "Color",
        "variantName2": "size",
        "variantName3": null,
        "variantOptionName1": "grey",
        "variantOptionName2": "lg",
        "variantOptionName3": null,
      },
      {
        "variantName1": "Color",
        "variantName2": "size",
        "variantName3": null,
        "variantOptionName1": "blue",
        "variantOptionName2": "sm",
        "variantOptionName3": null,
      },
      {
        "variantName1": "Color",
        "variantName2": "size",
        "variantName3": null,
        "variantOptionName1": "blue",
        "variantOptionName2": "md",
        "variantOptionName3": null,
      },
      {
        "variantName1": "Color",
        "variantName2": "size",
        "variantName3": null,
        "variantOptionName1": "blue",
        "variantOptionName2": "lg",
        "variantOptionName3": null,
      }
    ]
  }
}
